import type { Theme } from '@emotion/react';
import { globals } from 'common-ui';

export const buildCoreWidgets = (vars: Omit<Theme, 'widgets'>) => ({
  Loading: {},
  CollapseBox: {
    wrapper: `
        margin-bottom: 20px;
      `,
    header: `
        background-color: ${vars.colors.primary1};
        color: white;
        padding: 20px;
      `,
    body: `
        padding: 20px;
        background-color: ${vars.colors.white};
      `,
  },

  WinePreferences: {
    wrapper: `
        h3 {
          text-transform: uppercase;
          font-size: 28px;
        }
        em{
          display: block;
          font-weight: bold;
          margin-bottom: 20px;
        }
      `,
    loadingMsg: `
      `,
    errorMsg: `
      `,
    singleChoiceList: `
        margin-bottom: 30px;

        label{
          margin: 10px 0;
          input {
            margin-right: 10px;
          }
        }
      `,
    singleChoiceTable: `
        th,
        td {
          width: 25%;
        }

        td {
          text-align: center;
        }

        thead {
          th,
          td {
            padding: 10px 5px;
          }
        }

        tbody {
          th,
          td {
            font-weight: normal;
            padding: 15px 5px;
          }

          tr:last-child {
            th,
            td {
              border-bottom-width: 0;
            }
          }
        }
      `,
    multiSelectList: `
        label{
          margin: 10px 0;

          input {
            margin-right: 10px;
          }
        }
      `,
  },

  GlobalLayout: {
    previewMode: `
        position: fixed;
        bottom: 30px;
        width: 85%;
        text-align: center;
        left: 7.5%;
        border-radius: 8px;
        font-weight: ${vars.fonts.weightNormal};
        padding: 15px;
        background-color: ${vars.colors.white};
        box-shadow: 2px 2px 2px 2px ${vars.colors.primary1};
        z-index: 9999;
        p {
          margin: 0;
          color: ${vars.colors.black};
          a {
            margin-left: 5px;
            color: ${vars.colors.primary1};
          }
        }
      `,

    wrapper: `
      .no-results {
        .container {
          margin: 25px 0px;
        }
      }
      `,
  },
  GlobalHeader: {
    wrapper: `
        font-size: ${vars.fonts.sizeH5};
        &.mainHeader {
          z-index: 10 !important ;
          .sticky-header{
            position: fixed;
            top: 0;
            width: 100%;
            left: 0;
            z-index: 3;
            background-color: ${vars.colors.white};
            box-shadow: 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 0.625rem 0.9375rem -0.3125rem,
            rgba(0, 0, 0, 0.04) 0 0.4375rem 0.4375rem -0.3125rem;
            .search-navbar-container{
              padding: 0;
              transition:all 0.9s ease;
              -webkit-transition:all 0.9s ease;
              -moz-transition:all 0.9s ease;
            }
            .mantine-HoverCard-dropdown {
              padding: 12px 0;
            }
          }
        ${vars.breakpoints.xs} {
            position: sticky;
            top: 0;
            z-index: 500;
          }
          ${vars.breakpoints.lg} {
              position: relative;
              top: unset;
              z-index: 10;
          }
          .nav-overlay  {
            display: none;
            position: fixed;
            left: 0;
            right: 0;
            height: 100%;
            background: ${vars.colors.black};
            opacity: 0.6;
            z-index: 1;
          }
          .minicart-overlay {
            position: fixed;
            left: 0;
            right: 0;
            height: 100%;
            background: ${vars.colors.black};
            opacity: 0.6;
            z-index: 1;
            top: 0;
          }
          .active-nav-overlay  {
            display: block
          }
        }
        .state-selector-mobile {
          display: flex;
          justify-content: center;
          padding: 10px;
          background: ${vars.colors.primary3};
          ${vars.breakpoints.lg} {
            display: none;
          }
        }
      `,
    stripBanner: `
      min-height: 55px;
        div{
          > * {
            margin: 0;
            padding-top: 3px;
          }
        }
        .richtext-wrapper{
          padding-top: 10px;
        }
      `,
    tertiaryNav: `
      display: none;
      ${vars.breakpoints.lg} {
        display: block;
        padding: 1em 0;
      }
      .sticky-header &{
        display: none;
      }
      ul {
        display: flex;
        padding: 0;
        margin: 0;
        justify-content: end;
        li {
          list-style: none;
          margin-left: 48.3px;
          a {
            font-family: ${vars.fonts.familySecondary};
            color: ${vars.colors.black};
            font-weight: ${vars.fonts.weightNormal};
            text-transform: capitalize;
          }
        }
      }
    `,
    mainNavBarWrapper: `
        display: none;
        .logo-wrapper{
          display: flex;
          width: 49px;
          height: 64px;
          padding: 8px 0px;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }

        ${vars.breakpoints.lg} {
          display: flex;
          align-items: center;
          justify-content: space-around;

          .input-on-focus & {
            display: none;
          }
        }

        .tabPanes-wrapper{
          width: 100%;
        }

        .is-sticky{
          display: flex;
          gap: 33px;
          &.is-sticky-searchbar {
            gap: 0px;
          }
        }
        .searchbar-input-container {
          position: relative;
        }
        .isSearchBar {
            position: absolute;
            top: 11px;
            left: 15px;
        }

        .isStickyCancelContainer {
          .isStickyCancelButton {
            display: block;
            text-decoration: none;
            padding: 0px 20px 0 0px;
            background: transparent;
            color: ${vars.colors.black};
            border: 0;
            cursor: pointer;
            &:hover, &:focus {
              outline:0;
            }
          }
        }

        ${vars.breakpoints.lg} {
            border-left: 0;
            margin: auto;
            .isStickyCancelButton {
              display: none;
              padding: 0;
            }
          }



        .search-user-cart{
          display: flex;
          gap: 32px;
          width: 10%;
        }

        .topLevelLinks{
          display: flex;
          justify-content: center;
          width: 100%;
          .cms-conditional-container {
            display: flex;
          }
          & > div {
             display: flex;
             justify-content: center;
             width: 100%;
             & + div {
              display: none;
            }
          }
          .navigation-link .cms-conditional-container {
            flex-direction: column;
            a {
              text-wrap: initial;
              line-height: 18px;
              margin-bottom: 14px;
              width: fit-content;
            }
          }
        }

        .topLevelLink{
          padding-top: 0;
          padding-bottom: 0;
          &:hover .megaNavTab{
            color: ${vars.colors.grey50};
            text-decoration: underline;
            text-decoration-color: ${vars.colors.primary1};
            text-decoration-thickness: 4px;
          }
          .menu-banner-image img {
            height: auto;
          }
        }
        .megaNavTab:focus{
            text-decoration: none;
        }

        .isStickySearchBar{
          width: 100%;
        }

        .isSticky {
          color: ${vars.colors.black};
          font-family: ${vars.fonts.familySecondary};
          font-size: ${vars.fonts.sizeH5};
          font-style: normal;
          font-weight: ${vars.fonts.weightNormal};
          line-height: ${vars.fonts.lineHeightDefault};
          text-transform: uppercase;
          display: inline-block;
          text-underline-offset: ${vars.space.lg};
          padding: ${vars.space.lg} 0;

          &:hover{
            text-decoation: underline;
            text-decoration-color: ${vars.colors.primary1};
            text-decoration-thickness: 3px;
          }

          &.emphasize{
          color: ${vars.colors.primary1};
          font-family: ${vars.fonts.familySecondary};
          font-size: ${vars.fonts.sizeH5};
          font-style: normal;
          font-weight: ${vars.fonts.weightBold};
          line-height: ${vars.fonts.lineHeightDefault}; /* 171.429% */
          text-transform: uppercase;
          }
        }

        .megaNavTab {
          font-size: 18px;
          text-underline-offset: ${vars.space.lg};
          padding: ${vars.space.lg} 14px;
          display: inline-block;
          font-family: ${vars.fonts.headerMainNavTitle};
          color: ${vars.colors.grey50};
          letter-spacing: ${vars.fonts.fontLetterSpacing5};
          font-weight: ${vars.fonts.weightMediumPlus};
          ${vars.breakpoints.xl} {
            padding: ${vars.space.lg} 20px;
          }

          span {
            display: inline-block;
          }
          &:hover {
            text-decoration: none;
            span {
              position: relative;
              ::after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: -13px;
                height: 5px;
                background: ${vars.colors.primary1};
                z-index: 0;
              }
            }
          }

          &.emphasize, &.emphasize span {
            color: ${vars.colors.primary1};
            font-weight: ${vars.fonts.weightBold};
            white-space: nowrap;
          }
          &:focus{
            text-decoration: none;
          }
        }

        .mantine-HoverCard-dropdown{
          padding: 0;
          border: none;
          background: transparent;
          box-shadow: 0px 0px 0px;
          .header-main-nav-layout {
            background: ${vars.colors.white};
            border-radius: 0px 0px 12px 12px;
            box-shadow: 0px 0px 3px 0px #DEDEDE inset;
            .dynamicComponents {
              padding: 22px 40px;
              .richtext-wrapper {
                &.richtext-has-bg {
                  padding: 1rem;
                }
                p {
                  margin-top: 1em;
                  margin-bottom: 1em;
                  &:first-of-type {
                    margin-top: 0;
                  }
                  &:last-child {
                    margin-bottom: 0;
                  }
                }
              }
            }
            .navigation-link {
              a {
                letter-spacing: ${vars.fonts.fontLetterSpacing5};
              }
              > a {
                width: 100%;
                overflow-x: hidden;
                text-overflow: ellipsis;
              }
            }
          }
          .mantine-ScrollArea-root  {
            .widget-cms-column > div {
              margin: 0;
              width: 100%;
              max-width: 100%;
            }
          }
        }
      `,

    mainNavBarMenuTabPane: `
        text-align: left;
        margin-top: -8px;
        left: 0 !important;
        ${vars.breakpoints.xxl} {
          right: 0;
        }
        .header-main-nav-layout {
          h4{
            font-family: ${vars.fonts.headerMainNavSubTitle};
            font-size: 18px;
            font-weight: ${vars.fonts.weightBold};
            margin: 0 0 ${vars.space.lg} 0;
            color: ${vars.colors.primary1};
            letter-spacing: 0.01em;
            text-transform: unset;
          }
          a{
            line-height: 22px !important;
            font-size: ${vars.fonts.sizeH4};
            &:hover {
              color: ${vars.colors.primary1};
            }
          }
        }
      `,
    searchNavBar: `
      .state-selector {
        display: none;
        ${vars.breakpoints.lg} {
          display: block;
        }
      }
      .search-navbar-container {
        padding: 0;
        .grid-search-navbar-container{
          flex-wrap: nowrap;
        }
        .navbar-left-container {
          order: 2;
          display: flex;
          justify-content: center;
        }
        .navbar-center-container {
          position: relative;
          .sticky-header & {
            ${vars.breakpoints.lg} {
              position: initial;
              padding-right: 24px;
            }
            &.input-on-focus {
              position: relative;
            }
            max-width: none;
          }
          min-width: 83px;
          text-align: left;
          min-height: unset;
          display:flex;
          align-items: center;
          gap:10px;
          order: 1;
          ${vars.breakpoints.lg} {
            max-width: 480px;
          }
          ${vars.breakpoints.xl} {
            max-width: 540px;
          }
          ${vars.breakpoints.xxl} {
            max-width: 689px;
          }
          .sticky-nav-bar{
            display:none;
          }
          .sticky-header &{
            align-items: center;
            ${vars.breakpoints.lg} {
              .sticky-nav-bar{
                display:flex;
                width: 100%;
              }
            }
            .search-icon {
              display: initial;
            }
            .searchbar-grid-block-container {
              display: none;
              margin: 0 auto;
              right: 0;
              transition: all 1s;
              ${vars.breakpoints.lg} {
                max-width: 410px;
                position: fixed;
              }
              ${vars.breakpoints.xl} {
                max-width: 480px;
                position: fixed;
              }
              ${vars.breakpoints.xxl} {
                max-width: 612px;
                position: fixed;
              }
            }
            .header-search-bar{
              margin-left: auto;
            }
          }
          .search-overlay  {
            display: none
          }
          .isSearchBar {
            position: absolute;
            top: 5px;
            right: 5px;
            background: ${vars.colors.primary1};
            padding: 8px;
            border-radius: 50px;
            color: ${vars.colors.white};
            width: 36px;
            height: 36px;
          }
          .header-mainnav-mobile{
            ${vars.breakpoints.lg} {
              display:none;
            }
          }
          &.input-on-focus {
            + .navbar-right-container {
              .sticky-header & {
                display: block;
              }
            }
            .header-mainnav-mobile, .search-icon {
              display: none;
            }
            .searchbar-grid-block-container {
              display: block;
              .searchbar-grid  {
                background: ${vars.colors.white};
                position: relative;
              }
            }
            .suffix-icon, .searchbar-cancel-link {
              display: block;
            }
            .search-overlay  {
              display: block
            }
            .aa-Form {
              border: 0;
              ${vars.breakpoints.lg} {
                border: 1px solid ${vars.colors.black};
              }
            }
          }
        }
        .navbar-right-container {
          order: 3;
          padding-right: 21px;
          i {
            width: 28px;
            height: 28px;
          }
          & > div {
            gap: 0em;
            .favourites-col-container {
              display: none;
              ${vars.breakpoints.md} {
                display: block;
              }
            }
          }
          .sign-in-link {
            background: transparent;
            border: none;
            cursor: pointer;
            padding-left: 0px;
            padding-right: 0px;
            color: #000;
          }  
          .sticky-header &{
            .sign-in-link {
              span {
                display: none;
                vertical-align: middle;
                margin-left: 0.5em;
                color: ${vars.colors.black};
              }
            }
            .header-cart-price-container {
              display: none;
            }
            .header-cart-count-container {
              background: transparent;
              padding: 0em;
              .header-cart-grid-container {
                min-width: 90%;
                .header-cart-price-container {
                  display: none;
                }
                .cart-quantity{
                  display: initial;
                }
              }
            }
          }
        }
      }
      ${vars.breakpoints.lg} {
        border-bottom: 0.5px solid ${vars.colors.grey20};
        .search-navbar-container {
          padding: 0.8em 0;
          .navbar-left-container {
            order: 1;
            justify-content: flex-start;
            .sticky-header & {
              display:none;
            }
          }
          .navbar-center-container {
            min-width: unset;
            text-align: unset;
            min-height: 69px;
            flex: auto;
            order: 2
          }
          .navbar-right-container {
            & > div {
              .favourites-col-container {
                display: flex;
              }
              .sticky-header & .favourites-col-container {

              }
            }
          }
        }
      }
      ${vars.breakpoints.md} {
        .navbar-center-container {
          min-width: 106px;
        }
        .search-navbar-container {
          .navbar-right-container {
            & > div {
              gap: 1em;
            }
          }
        }
      }

      //TODO: unhide when DSP-259 implemented
      .hamburger-menu-icon {
        display: none;
      }
    `,
    headerLogo: `
      img {
        display: block;
        max-width: 10em;
        width: 100%;

        ${vars.breakpoints.lg} {
        max-width: 13.5em;
        }
      }
    `,
    stickymainNavWrapper: `
      #header-logo img {
        width: auto;
        min-width: auto;
      }
      .topLevelLink {
        .megaNavTab, .navigation-link h4 {
          font-size: ${vars.fonts.sizeDefault};
        }
        .navigation-link a {
          font-size: ${vars.fonts.sizeDefault};
          line-height: 18px !important;
          letter-spacing: ${vars.fonts.fontLetterSpacing5};
        }
      }
    `,
    headerFavourites: `
      a {
        &.icon-hover {
          color: ${vars.colors.primary1};
        }
        &.favourites-link {
          text-decoration: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
          span {
            display: none;

            .sticky-header & {
              display: none;
            }
            ${vars.breakpoints.lg} {
              display: block;
            }
          }
        }
      }
    `,
    headerSignIn: `
      color: ${vars.colors.black};
      .user-logged-in-label {
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 5px;
      }
      .sign-in-label {
        width: 2em;
        height: 2em;
        background: ${vars.colors.headerSignInBtnSmall};
        color: ${vars.colors.white};
        display: inline-flex;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        vertical-align: middle;
      }
      .sign-in-name {
        margin-left: 0.3em;
        display: none;
        text-transform: capitalize;
        max-width: 90px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        ${vars.breakpoints.lg} {
          display: inline-block;
          .sticky-header & {
            display: none;
          }
        }
      }
      .sign-in-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        &:hover {
          text-decoration: none;
        }
        span {
          display: none;
          vertical-align: middle;
          color: ${vars.colors.black};
          ${vars.breakpoints.lg} {
            display: inline-block;
          }
        }
      }
    `,
    headerCart: `
      display: inline-flex;
      border-radius: 0.35em;
      color: ${vars.colors.black};
      background: transparent;
      position: relative;
      padding: 0em;
      .header-cart-link:hover {
          text-decoration: none;
      }
      .header-cart-grid-container {
        margin-left: 0;
        margin-right: 0;
        .header-cart-price-container {
          display: none;
          padding-left: 0.75em !important;
          font-family: ${vars.fonts.familySecondary};
          font-weight: ${vars.fonts.weightNormal};
        }
        .header-cart-icon-container {
          position: relative;
          padding-right: 0.75em;
          .cart-quantity {
            position: absolute;
            border-radius: 0.8em;
            min-width: 2em;
            min-height: 1.65em;
            background: ${vars.colors.headerCartBtnSmall};
            top: 2px;
            left: 1.45em;
            font-family: ${vars.fonts.familySecondary};
            font-weight: ${vars.fonts.weightBold};
            font-size: 0.78em;
            padding: 1.5px 3px 0px;
            line-height: ${vars.fonts.sizeLarge};
            text-align: center;
            display: inline-block;
            color: ${vars.colors.white};
          }
        }
      }
      &.has-quantity {
        :not(.sticky-header) &{
          background: transparent;
          color: ${vars.colors.black};
          .header-cart-link {
            color: ${vars.colors.black};
          }
          .header-cart-grid-container {
            .header-cart-icon-container {
              padding-right: 0.75em;
              .cart-quantity {
                background: ${vars.colors.headerCartBtnSmall};
                color: ${vars.colors.white};
              }
            }
          }
        }
      }
      .cart-confirmation-popup {
        background: ${vars.colors.white};
        border: 1px solid ${vars.colors.grey20};
        border-radius: 3px;
        padding: 10px;
        position: absolute;
        right: 0px;
        top: 68px;
        min-width: 180px;
        white-space: nowrap;
        color: ${vars.colors.black};
        display: none;
        i {
          padding-right: 0.15em;
          color: ${vars.colors.secondary6};
        }
        &.fadedown {
        ${vars.mixins.animateFadeInDown};
          display: block;
          z-index: 201;
        }
        &.fadeout {
          ${vars.mixins.animateFadeOutUp};
        }
        &::before {
          background: ${vars.colors.white};
          border: solid ${vars.colors.grey20};
          border-width: 0 1px 1px 0;
          content: '';
          display: block;
          left: 150px;
          padding: 7px;
          position: absolute;
          top: -8px;
          transform: rotate(225deg);
          width: 1px;
          z-index: 1;
        }
      }
      .header-cart-price-container {
        display:none;
      }
      .header-cart-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
      }
      .header-cart-icon-container {
        position: relative;
      }
      .cart-quantity {
        position: absolute;
        background: ${vars.colors.primary1};
        border-radius: 50px;
        border: 1px solid ${vars.colors.white};
        display: flex;
        align-items: center;
        justify-content: center;
        top: -7px;
        right: -8px;
        padding: 9px 5px;
        color: ${vars.colors.white};
        font-size: 14px;
        font-weight: 500;
        min-width: 20px;
        height: 20px;
      }

      ${vars.breakpoints.lg} {
        .header-cart-price-container {
          display: block;
        }

        .header-cart-grid-container {
          .header-cart-price-container {
            display: block;
          }
          .header-cart-icon-container {
            padding-right: 0;
            .cart-quantity {
              display: none;
            }
          }
        }
        &.has-quantity {
          ${vars.breakpoints.lg} {
            .header-cart-link, div.header-cart-link {
              .header-cart-price-container span,.header-cart-icon-container i {

              }
              .sticky-header & {
                .header-cart-price-container span,.header-cart-icon-container i {
                  color: ${vars.colors.black};
                }
              }
            }
            .header-cart-grid-container {
              .header-cart-icon-container {
                padding-right: 0.75em;
                .cart-quantity {
                  display: inline-block;
                  background: ${vars.colors.white};
                  color: ${vars.colors.headerCartBtn};
                  .sticky-header & {
                    background: ${vars.colors.headerCartBtn};
                    color: ${vars.colors.white};
                  }
                }
              }
            }
          }
          :not(.sticky-header) &{
            background: ${vars.colors.headerCartBtn};
            color: ${vars.colors.white};
            .header-cart-link {
              color: ${vars.colors.white};
            }
            .header-cart-grid-container {
              .header-cart-icon-container {
                .cart-quantity {
                  display: inline-block;
                  background: ${vars.colors.white};
                  color: ${vars.colors.headerCartBtn};
                }
              }
            }
          }
        }
      }
    `,
    stickyHeader: `
        position: sticky;
        top: 0;
        background: ${vars.colors.white};
        z-index: 1;
        border-radius: 0;
        .stickyMainNavBar-container{
          background-color: white;
        }
    `,
    headerSearchInput: `
      .search-icon {
        display: block;
        ${vars.breakpoints.lg} {
          display: none;
        }
      }
      .searchbar-grid-block-container {
        position: fixed;
        top: 0px;
        left:0;
        width: 100%;
        display: none;
        box-shadow: 0px 4px 25px rgb(0 0 0 / 6%);
        border-radius: 0;
        background: ${vars.colors.white};
        z-index: 1;
        min-width: 30%;
        transition: min-width 1s ease-out;
        ${vars.breakpoints.lg} {
          position: absolute;
          left: 0px;
          width: 100%;
          display: block;
          box-shadow: 0 0 0;
        }
        .searchbar-input-container {
          min-width: unset;
          position: relative;
          input {
            background-color: ${vars.colors.white};
            font-size: ${vars.fonts.sizeDefault};
            font-family: ${vars.fonts.familySecondary};
            width: 100%;
            padding: 10px 16px;
            line-height: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            border: 0;
            border-radius: 0;
            &:focus {
              outline: none;
              border: 0;
              &::placeholder {
                opacity: 0;
              }
            }
            &:disabled {
              cursor: default;
            }
            &::placeholder {
              color: ${vars.colors.grey40};
            }
            &:not(:placeholder-shown) ~ .suffix-icon {
              display: block;
            }
            // This is a temporary fix will be remove in sprint 10
            &.temp {
              border: 1px solid ${vars.colors.grey20};
              border-radius: 50px !important;
              box-sizing: border-box;
              padding: 10px 16px;
              height: 46px
            }
          }
          .prefix-icon {
            position: absolute;
            top: 5px;
            right: 5px;
            background: ${vars.colors.primary1};
            padding: 8px;
            border-radius: 50px;
            color: ${vars.colors.white};
            width: 36px;
            height: 36px;
            display: none;
            ${vars.breakpoints.lg} {
              display: block;
              font-size: 14px;
            }
            i {
              width: 20px;
              height: 20px;
            }
          }

          .suffix-icon {
            display: none;
            position: absolute;
            top: 10px;
            right: 6px;
            cursor: pointer;
            ${vars.breakpoints.lg} {
              right: 15px;
            }
          }
        }
        .searchbar-cancel-container {
          border-left: 1px solid ${vars.colors.grey20};
          outline: none;
          ${vars.breakpoints.lg} {
            position: absolute;
            right: -15%;
          }
          ${vars.breakpoints.xxl} {
            position: absolute;
            right: -12%;
          }
          .searchbar-cancel-link {
            display: block;
            text-decoration: none;
            padding: 0px 20px 0 16px;
            background: transparent;
            color: ${vars.colors.black};
            border: 0;
            cursor: pointer;
            &:hover, &:focus {
              outline:0;
            }
          }

          ${vars.breakpoints.lg} {
            border-left: 0;
            .searchbar-cancel-link {
              display: none;
              padding: 0;
            }
          }
        }
      }
    `,
    navStickyButton: `
      text-align: center;
      padding: 24px 0;
      border-top: 1px solid #DEDEDE;
      a + a {
        margin-left: 10px;
      }
    `,
  },
  Search: {
    noResults: `
      .no-results {
        .container {
          text-align: center;
          margin: 30px 0px;
          .title {
            font-size: ${vars.fonts.sizeH2};
            font-weight: ${vars.fonts.weightBold};
            margin-bottom: 5px;
          }
        }

        .query {
          font-size: ${vars.fonts.sizeH2};
        }
      }
      `,
    wrapper: `
      max-width: ${vars.breakpointWidths?.xxl}px;
      margin-left: auto;
      margin-right: auto;
      // padding: 0px 15px;
      ${vars.breakpoints.xxl} {
        padding: 0px;
      }
      h1 {
        margin-top: 0px;
      }
      .facets-navigation {
        padding:0 16px 16px 0;
        @media (max-width: 767px) {
          display: none;
        }
      }
      .show {
        display: block;
      }
      .hide {
        display: none;
      }
      .search-results-listing.loading {
        display: none;
      }
      .search-results-listing {
        .trending-items-container {
          max-width: calc(100vw - 32px);
          ${vars.breakpoints.sm} {
            max-width: calc(100vw - 354px);
          }
          ${vars.breakpoints.lg} {
             max-width: calc(100vw - 434px);
          }
          ${vars.breakpoints.xxl} {
            max-width: calc(1680px - 434px)
          }
        }
        &.uk .plp-qty-selector-enhanced {
          .grid-addto-cart-btn, .loading-add-to-cart-btn {
            height: 44px;
            .btn-text-short { display: none; }
            @media (min-width: 860px) and (max-width: 1479px), (min-width: 488px) and (max-width: 767px) {
              .btn-text-full { display: none; }
              .btn-text-short { display: inline !important; }
            }
          }
        }
        .price-per-litre {
          font-size: 10px;
          font-weight: 300;
          width: auto;
        }
      }
      .search-toolbar-container + .loaderContainer {
        ${vars.breakpoints.sm} {
          margin-top: 250px;
        }
        @media (max-width: 767px) {
          margin: 100px 0;
        }
      }
      .filter-header{
        display:flex;
        align-items: baseline;
        justify-content: space-between;
        p {
          font-family: ${vars.fonts.familyTertiary};
          font-size: 26px;
          font-weight: ${vars.fonts.weightMediumPlus};
        }

      .clear-refinements {
        background: none;
        color: ${vars.colors.black};
        font-size: ${vars.fonts.sizeLarge};
        line-height: ${vars.fonts.lineHeightDefault};
        text-decoration-line: underline;
        padding: 0;
        margin: 0 2px 0 0;
        cursor: pointer;
        border: none;
        box-shadow: none;
        &:hover {
          background: none;
          color: ${vars.colors.black};
          text-decoration-line: underline;
        }
      }
    }

      margin-top: 15px;
      .search-toolbar-container {
        .hits-per-page {
          display: none;
          ${vars.breakpoints.sm} {
            display: block;
          }
        }
        ${vars.breakpoints.sm} {
          display: flex;
          gap: 15px;
          align-items: baseline;
          justify-content: space-between;
          margin-bottom: 16px;
        }
        .toolbar-start{
          .refinements {
            display: none;
            ${vars.breakpoints.sm} {
              display: block;
            }
          }
          flex:1 0 0;
          ${vars.breakpoints.md} {
            padding-bottom: 16px;
          }
      }
        .toolbar-end {
          ${vars.breakpoints.sm} {
            display: flex;
            flex-wrap: wrap;
            flex:0.9 0 0;
            justify-content:end;
            align-items: end;
            gap: 15px;
            ${vars.breakpoints.lg} {
              gap: 25px;
            }
          }
        }

      .quick-toggle-container {
        display: none;
        ${vars.breakpoints.md} {
          display: flex; // hiding the Grid view. The list view is default, So hiding the toggle icons;
          align-items: center;

          button {
            border: 1px solid ${vars.colors.grey80};
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            &.list-icon {
              background-color: ${vars.colors.white};
              border-radius: 5px 0px 0px 5px;
              svg {
                path {
                  fill: ${vars.colors.grey80};
                }
              }
              &.active {
                svg {
                  path {
                    fill: ${vars.colors.black};
                  }
                }
                border: 1px solid ${vars.colors.black};
                background-color: ${vars.colors.grey10};
              }
            }
            &.grid-icon {
              background-color: ${vars.colors.white};
              border-radius: 0px 5px 5px 0px;
              svg {
                path {
                  fill: ${vars.colors.grey80};
                }
              }
              &.active {
                border: 1px solid ${vars.colors.black};
                background-color: ${vars.colors.grey10};
                svg {
                  path {
                    fill: ${vars.colors.black};
                  }
                }
              }
            }
          }
        }
      }
    }

    .category-intro-copy {
      text-align: center;
      border: 1px solid ${vars.colors.grey20};
      border-radius: 10px;
      margin-bottom: 15px;
      padding: 24px 16px 32px;
      margin-top: 25px;
      h1 {
        &.Red, &.Rose, &.dessert {
          color: ${vars.colors.primary1};
        }
        &.White, &.Beer {
          color: #D89B00;
        }
        &.Fortified, &.Sparkling, &.Cider {
          color: ${vars.colors.primary2};
        }
        &.Mixed {
          color: ${vars.colors.secondary1};
        }
        margin-bottom: 20px;
      }
      @media (max-width: 767px) {
        p, span {
          font-size: 16px !important;
        }
      }
    }

    .category-faq {
      margin: 30px 0px;
      .heading {
        font-family: ${vars.fonts.familyTertiary};
        font-weight: ${vars.fonts.weightNormal};
        font-size: ${vars.fonts.sizeH2};
        margin-bottom: 15px;
        text-transform: capitalize;
      }

      u {
        text-decoration-line: blink;
        text-decoration: none;

        a {
          text-decoration: underline;
        }
      }
    }

    .category-banner {
      margin-bottom: 15px;
      margin-top: 25px;

      p u {
        text-decoration-line: blink;
        text-decoration: none;

        a {
          text-decoration: underline;
        }
      }
    }
    display: grid;
    grid-gap: 24px;
      ${vars.breakpoints.xs} {
        grid-template-columns: auto;
      }
      ${vars.breakpoints.sm} {
        grid-template-columns: 270px 1fr;
      }

      ${vars.breakpoints.md} {
        grid-template-columns: 228px 1fr;
      }
      ${vars.breakpoints.lg} {
        grid-template-columns: 272px 1fr;
      }
      ${vars.breakpoints.xl} {
        grid-template-columns: 292px 1fr;
      }
      ${vars.breakpoints.xxl} {
        grid-template-columns: 402px 1fr;
      }
    .facets-navigation.hide-refinementlist{
      display : none;
    }

    .sort-filter-block{
      display:flex;
      gap: 10px;
      @media (min-width: 768px) {
        .mobile-filter-box {
          display: none;
        }
      }
    }

    @media (max-width: 767px) {
        .sort-filter-block{
          gap: 0px;
          padding-bottom:16px;
          .filter-box {
            display: flex;
            height: 40px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            flex: 1 0 0;
            border-radius: 5px 0px 0px 5px;
            border: 1px solid #303030;
            .applied-filter-red-dot-icon {
              display: inline-block;
              width: 9px;
              height: 9px;
              background-color: #D7363B;
              border-radius: 50%;
              position: relative;
              left: 42px;
              bottom: 8.5px;
              border: 1.5px solid #FFFFFF;
            }
          }
          .sort-box {
            border-radius: 0px 5px 5px 0px;
            border-width: 1px 1px 1px 0;
            border-color: #303030;
            border-style: solid;
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1 0 0;
            & .label {
              display:none;
            }
            & .options {
              border:none;
              max-height:38px;
            }
          }
        }
      }
      .refinement-drawer{
        position: fixed;
        background-color: ${vars.colors.lwDrGray};
        z-index:500;
        .drawer-container{
          position: fixed;
          width: 100%;
          top: 0px;
          left: 0px;
          bottom: 0px;
          max-height: 100%;
          background-color: ${vars.colors.grey80};
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .drawer-section{
            outline: 0px;
            -webkit-tap-highlight-color: transparent;
            display: block;
            text-decoration: none;
            background-color: ${vars.colors.white};
            box-sizing: border-box;
            flex: 0 0 27.5rem;
            max-width: 100%;
            max-height: 100%;
            height: 100%;
            border-radius: 0px;
            overflow-y: auto;

            .drawer-body{
              position:relative;
              min-height: 100vh;
              padding: 1rem;
              & >:nth-of-type(2) .heading{
                border-top:none;
              }
              .filter-header{
                position:sticky;
                top:0;
                background:${vars.colors.white};
                z-index:1;
                display: flex;
                flex-direction: column;

              & :first-of-type{
                align-self: end;
                }
            .header-row{
              display:flex;
              justify-content:space-between;
              align-items:center;
              width:100%;
            }
          }
          .bottom-button{
            width:100%;
            position: sticky;
            margin: auto;
            background:${vars.colors.white};
            padding:10px;
            display:flex;
            justify-content:space-between;
            gap:10px;
            margin-bottom: 0;
            bottom:0;


            & button{
                flex: 1;
                width:100%;
              display: flex;
              padding: 10px 16px;
              justify-content: center;
              align-items: center;
              gap: 4px;
              flex: 1 0 0;
              border-radius: 8px;
              border: 1px solid ${vars.colors.secondary6};
            }

            & :first-of-type{
                background:${vars.colors.white};
                color:black;
                padding: 10px 16px;
                border-radius: 8px;
                border: 1px solid ${vars.colors.secondary6};
            }
          }

            }
          }
        }
      }
      body:has(.drawer-body:not(.refinement-drawer-show))
    {
      overflow: visible;
    }

      body:has(.drawer-body.refinement-drawer-show){
        overflow: hidden;
      }
    .refinement-drawer.refinement-drawer-hide{
      display:none;
      }
      .facets-navigation >:nth-of-type(2) .heading {
      border-top:none;
      }
      `,
    refinements: `
      .show {
        display: block;
      }
      .hide {
        display: none;
      }
      .text-capitalize {
        text-transform: capitalize;
      }
      .line-seperator {
        border-top: 1px solid #dadada;
      }
      .heading {
        display: flex;
        align-items: center;
        background-color: ${vars.colors.white};
        justify-content: space-between;
        border-top: 1px solid #dadada;
        .text-wrap {
          text-wrap: wrap;
          font-family: ${vars.fonts.familySecondary};
        }
        .title {
          font-weight: ${vars.fonts.weightMediumPlus};
        }
        button {
          text-transform: uppercase;
          background: transparent;
          padding: 16px 40px 16px 0px;
          line-height: ${vars.fonts.lineHeightDefault};
          color: black;
          width: 100%;
          text-align: left;
          border-radius: 0px;
          font-size: ${vars.fonts.sizeLarge};
          font-weight: ${vars.fonts.weightBold};
          border-width: 0px;
          position: relative;
          font-family: ${vars.fonts.familySecondary};
          &:hover {
            cursor: pointer;
          }
          i {
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
          }
        }
      }

      .ais-RefinementList-searchBox {
        margin-bottom: 12px;
        .ais-SearchBox-form {
          height: 44px;
          .ais-SearchBox-input {
            padding: 0px ${vars.fonts.sizeLarge};
            border-radius: 5px;
            border: 1px solid var(--neutral-colours-cccccc, ${vars.colors.grey20});
            box-shadow: none;
            &::placeholder {
              color: ${vars.colors.grey80};
            }
          }
          button {
            border: none;
            background: white;
            padding: 0;
            position: absolute;
            right: ${vars.fonts.sizeLarge};
            width: 20px;
            height: 20px;
            top: 50%;
            transform: translateY(-50%);
            svg {
              width: 20px;
              height: 20px;
              fill: ${vars.colors.black};
            }
          }
          &:before {
            content: none;
          }
        }
      }
      .ais-RefinementList-noResults{
        color:red;
        padding-bottom: 16px;
      }
      ul.ais-RefinementList-list {
        margin: 0;
        li {
          &.ais-RefinementList-item {
            padding-bottom: 18px;
            .ais-RefinementList-label {
              .ais-RefinementList-checkbox {
                width: 20px;
                height: 20px;
                box-shadow: none;
                border-radius: 2px;
                color: ${vars.colors.facetCheckboxColor};
              }
              .ais-RefinementList-labelText {
                font-size: ${vars.fonts.sizeLarge};
                font-weight: 400;
                line-height: ${vars.fonts.lineHeightDefault};
                padding-left: 8px;
                color: ${vars.colors.facetLabelColor};
                .ais-Highlight-highlighted {
                  background-color: transparent;
                  color: ${vars.colors.black};
                }
              }
              .ais-RefinementList-count {
                font-size: ${vars.fonts.sizeDefault};
                line-height: ${vars.fonts.lineHeightDefault};
                background: none;
                border: none;
                padding: 0;
                margin-left: 5px;
                &:before {
                  content: '(';
                }
                &:after {
                  content: ')';
                }
              }
              .rating-star {
                margin-left: 5px;
              }
            }
          }
          &.ais-RefinementList-item--selected .ais-RefinementList-checkbox:checked,
          .ais-GeoSearch-input:checked {
           background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Checkbox'%3E%3Crect width='18' height='18' fill='var(--checkbox-bg-color, ${vars.colors.svgCheckboxBg})'/%3E%3Cpath id='Vector' d='M14 5L7.125 12L4 8.81818' stroke='var(--checkbox-stroke-color, ${vars.colors.svgCheckboxStroke})' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E%0A");
           background-size: 18px;
            color: transparent;
          }
        }
      }
      .ais-RefinementList-showMore:not([disabled]),
      .clear-refinements {
        background: none;
        color: ${vars.colors.grey50};
        font-size: ${vars.fonts.sizeLarge};
        line-height: ${vars.fonts.lineHeightDefault};
        text-decoration-line: underline;
        padding: 0;
        margin: 0 0 16px 0;
        cursor: pointer;
        border: none;
        box-shadow: none;
        &:hover {
          background: none;
          color: ${vars.colors.black};
          text-decoration-line: underline;
        }
      }
      .ais-RefinementList-showMore:not([disabled]) {
        position: absolute;
      }
      .clear-refinements-container {
        display: flex;
        justify-content: end;
        padding-right: 6px;
      }
      // .ais-RefinementList:has(.ais-RefinementList-showMore:not([disabled]))
      //   ~ .clear-refinements-container:empty {
      //   height: 40px;
      // }

      .clear-refinements-container.have-showmore:empty{
        height:40px
      }
      .ais-RefinementList:has(.ais-RefinementList-showMore[disabled])
        ~ .clear-refinements-container:empty {
        height: 0;
      }

      `,
    currentRefinement: `
      .row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 10px;
      }

    .refinements {
      display: flex;
      gap: 4px;
      flex-wrap: wrap;
    }
    button {
      &.refinement-item {
        // width: 100%;
        color: ${vars.colors.white};
        display: flex;
        border-width: 1px;
        align-items: center;
        justify-content: space-between;
        border-radius: 0px;
        border-color: transparent;
        background-color: #01193c;
        border-radius: 15px;
        padding: 4px 15px;
        gap: 10px;
        margin-bottom: 4px;
        line-height: 14px;
        svg {
          path {
            stroke: ${vars.colors.white};
          }
        }
        :hover {
          cursor: pointer;
          border-color: #eee;
          filter: brightness(55%);
        }
        &.collapse-refinement{
          background-color:  ${vars.colors.lWHUELWBlue};
          color:black;
          filter: unset !important;
        }
      }
      &.clear-refinements {
        width: 100%;
        color: #333;
        background: transparent;
        text-decoration-line: underline;
        line-height: 24px;
        font-size: ${vars.fonts.sizeLarge};
        padding: 0px;
        margin-left:8px;
        :hover {
          text-transform: underline;
          cursor: pointer;
        }
      }
    }
    @media (max-width: 767px) {
      margin-bottom:14px;
      gap: 0;
      .refinements{
        gap:4px;
        flex-wrap:wrap;
        margin-bottom:5px;
        .refinement-item{
        margin-bottom: 0px;
        }
      }
      .refinement-item{

        &.collapse-refinement{
          background-color:  ${vars.colors.lWHUELWBlue};
          color:black;
          filter: unset !important;
        }
      }
      .clear-refinements-container{

          display: none;

      }

    }
    .text-capitalize {
      text-transform: capitalize;
    }
      `,
    sorting: `
      .results {
        .options {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border: 1px solid #222222;
          height: 40px;
          padding: 5px 5px 5px 10px;
          border-radius: 5px;
          font-family: ${vars.fonts.familySecondary};
          ${vars.breakpoints.lg} {
            min-width: 200px;
          }
          .label {
            font-weight: 700;
            line-height: 24px;
            margin-right: 7px;
          }
        }
      }
      .ais-SortBy-select {
        border: none;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Ctitle%3Edown-arrow%3C%2Ftitle%3E%3Cg%20fill%3D%22%23000000%22%3E%3Cpath%20d%3D%22M10.293%2C3.293%2C6%2C7.586%2C1.707%2C3.293A1%2C1%2C0%2C0%2C0%2C.293%2C4.707l5%2C5a1%2C1%2C0%2C0%2C0%2C1.414%2C0l5-5a1%2C1%2C0%2C1%2C0-1.414-1.414Z%22%20fill%3D%22%23000000%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E')
          96% / 10% no-repeat;
        width: 120px;
        padding: 0;
      }`,
    pagination: `
      .results {
        .options {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border: 1px solid #222222;
          height: 40px;
          padding: 5px 5px 5px 10px;
          border-radius: 5px;
          min-width: 190px;
          font-family: ${vars.fonts.familySecondary};
          .label {
            font-weight: 700;
            line-height: 24px;
            margin-right: 7px;
          }
        }
        @media (max-width: 767px) {
          display: none;
        }
      }
      .ais-HitsPerPage-select {
        border: none;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Ctitle%3Edown-arrow%3C%2Ftitle%3E%3Cg%20fill%3D%22%23000000%22%3E%3Cpath%20d%3D%22M10.293%2C3.293%2C6%2C7.586%2C1.707%2C3.293A1%2C1%2C0%2C0%2C0%2C.293%2C4.707l5%2C5a1%2C1%2C0%2C0%2C0%2C1.414%2C0l5-5a1%2C1%2C0%2C1%2C0-1.414-1.414Z%22%20fill%3D%22%23000000%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E')
          85% / 25% no-repeat;
        width: 50px;
        padding: 0;
      }
      `,
    accordionWrapper: `
      .accordion-item {
        border-bottom: 1px solid ${vars.colors.grey20};
        padding: 10px 0px;
        // display: flex;
        align-items: center; /* Center the text and icon vertically */
        cursor: pointer;
      }

      .accordion-title {
        display: flex;
        justify-content: space-between;
        padding-right: 10px;
        align-items: center;
        .title {
          font-family: ${vars.fonts.familySecondary};
          font-size: 1.2em;
          font-weight: ${vars.fonts.weightBold};
          text-transform: capitalize;
          margin:0;
          padding:0;
        }
      }

      .accordion-icon {
        margin-left: 8px; /* Add some space between the text and icon */
        svg {
          max-height: 10px;
        }
      }
      .accordion-content {
        display: none;
        &.show-accordion {
          display: block;
        }
      }
      `,
    quickViewWrapper: `
      .description-title .mantine-gm39d{
        font-weight: ${vars.fonts.weightMediumPlus};
        font-size: 16px;
      }
        &.quick-view-modal-container {
          .mantine-Modal-content .mantine-Modal-header {
            justify-content: flex-end;
          }
          &.rate-review {
            .mantine-Modal-body, .mantine-Modal-header {
              background-color: ${vars.colors.primary3};
            }
          }
        }s
        .mantine-Modal-overlay {
          z-index: 500;
        }
        .mantine-Modal-inner {
          z-index: 500;
          @media (max-width: 767px) {
            padding: 0;
            align-items: unset;
          }
        }
        .mantine-Modal-content {
          padding: 20px;
          border-radius: 10px;
          background: #F8F5EF;
          .mantine-Modal-header {
            background: #F8F5EF;
            .mantine-Modal-title {
              color: #000;
              font-size: 30px;
              font-weight: 500;
            }
            .mantine-CloseButton-root {
              padding: 0;
              line-height: 0;
              background: transparent;
              color: ${vars.colors.black};
              width: auto;
              height: auto;
              border: none;
              svg {
                width: 32px !important;
                height: 32px !important;
              }
            }
          }
          .mantine-Modal-body {
            padding: 0px;
            padding-top: 0;
            .PDP-title {
              margin-top: 0;
              font-size: 38px;
              line-height: 52px;
              @media (max-width: 767px) {
                font-size: 25px;
                line-height: 28px;
              }
            }
            .submission-success {
              text-align: center;
            }
            .table-container {
              header, .row {
                display: flex;
              }
              header {
                .column {
                  font-weight: ${vars.fonts.weightBold};
                }
              }
              .row {
                border-bottom: 1px solid ${vars.colors.grey20};

              }
              .column {
                flex: 1;
                padding: 10px 0px;
              }
            }
            .product-main-container {
              display: flex;
              .w-100 {
                width: 100%;
              }
              .product-image-container {
                max-width: 217px;
                position: relative;
                .image-container {
                  text-align: center;
                  position: relative;
                  img {
                    min-height: 400px;
                    min-width: 112px;
                    &.case {
                      min-height: 275px;
                      min-width: 306px;
                    }
                  }
                }
                .wine-details {
                  ul {
                    list-style: none;
                    margin-top: 30px;
                    padding-left: 30px;
                    li {
                      padding-bottom: 10px;
                      display: flex;
                      align-items: center;
                      a {
                        display: flex;
                        align-items: center;
                      }
                      i, img {
                        width: 32px;
                        margin-right: 10px;
                      }
                      &:last-child {
                        padding-bottom: 0px;
                      }
                    }
                  }
                }
                &.case {
                  max-width: 320px;
                }
              }
              .product-content-container {
                margin-left: 24px;
                @media (max-width: 767px) {
                  margin-left: 0px;
                  margin-top: 20px;
                }
                // .rating-country-container {
                //   display: flex;
                //   align-items: center;
                //   justify-content: space-between;
                //   @media (max-width: 767px) {
                //     justify-content: unset;
                //   }
                //   .rating {
                //     ${vars.breakpoints.xl} {
                //       display: flex;
                //       gap: 5px;
                //     }
                //     .star-icons {
                        margin-right:4px;
                //       ${vars.breakpoints.xl} {
                //         gap: 5px;
                //         display: inline-flex;
                //       }
                //     }
                //     .rating-cout {
                //       margin: 0 15px 0;
                //       font-size: ${vars.fonts.sizeDefault};
                //       font-weight: ${vars.fonts.weightBold};
                //     }
                //     .review-count {
                //       text-decoration: underline;
                //     }
                //   }
                //   .country {
                //     display: flex;
                //     align-items: center;
                //     font-size: ${vars.fonts.sizeLarge};
                //     line-height: ${vars.fonts.lineHeightDefault};
                //     img, svg {
                //       margin-right: 10px;
                //       @media (max-width: 767px) {
                //         width: 24px;
                //       }
                //     }
                //     @media (max-width: 767px) {
                //       font-size: 12px;
                //       margin-left: 25px;
                //     }
                //   }
                // }
                .image-price-container {
                  border-bottom: 1px solid ${vars.colors.grey20};
                }
                .image-container {
                  text-align: center;
                  margin: 30px 0;
                }
                .wine-details {
                  margin-top: 30px;
                  ul {
                    list-style-type: none;
                    padding: 0;
                    height: 100px;
                    li {
                      display: flex;
                      align-items: center;
                      margin-bottom: 25px;
                      float: left;
                      width: 160px;
                      a {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        &:hover {
                          text-decoration: none;
                        }
                      }
                      i {
                        margin-right: 10px;
                        width: 24px;
                        font-size: 24px;
                      }
                      svg {
                        margin-right: 10px;
                        width: 24px;
                        height: 24px;
                      }
                    }
                  }
                }
                .money-back-guarantee {
                  background-color: ${vars.colors.lWHUELWBlue};
                  padding: 15px;
                  margin: 30px 0;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .content {
                    max-width: 429px;
                    .descp {
                      font-weight: ${vars.fonts.weightBold};
                      padding-bottom: 10px;
                    }
                  }
                  .icon i:before {
                    font-size: 44px;
                  }
                }
                &.case {
                  .title-rating-container, .description-container {
                    display: none;
                  }
                }
              }
              @media (min-width: 768px) {
                .desktopOnly {
                  display: block;
                }
                .mobileOnly {
                  display: none;
                }
              }
              @media (max-width: 767px) {
                .desktopOnly {
                  display: none;
                }
                .mobileOnly {
                  display: block;
                }
              }
            }
          }
        }
      `,
    sliderWrapper: `
        .price-heading {
          line-height: ${vars.fonts.lineHeightDefault};
          text-transform: uppercase;
          // margin: 25px 0 15px;
          padding: 16px 0px;
          font-size: ${vars.fonts.sizeLarge};
          font-weight: ${vars.fonts.weightBold};
          border-top: 1px solid #dadada;

        }
        .slider-root {
          position: relative;
          display: flex;
          align-items: center;
          margin: 25px 10px 40px 10px;
          .slider-track {
            position: relative;
            flex-grow: 1;
            background-color: #969696;
            height: 4px;
            border-radius: 9999px;
            .slider-range {
              position: absolute;
              background-color: ${vars.colors.primary1};
              height: 100%;
            }
          }
          .slider-thumb {
            position: relative;
            display: block;
            width: 12px;
            height: 12px;
            background-color: ${vars.colors.primary1};
            border-radius: 9999px;
            cursor: pointer;
            &[aria-label='Minimum']:after {
              left: 0;
            }
            &[aria-label='Maximum']:after {
              right: 0;
            }
            &:after {
              position: absolute;
              bottom: 15px;
              content: '£'attr(aria-valuenow);
              font-size: 12px;
              line-height: 18px;
            }
            &:focus-visible {
              outline: none;
            }
          }
        }
        .range-input {
          display: flex;
          justify-content: center;
          margin: 20px 10px;
          .ais-RangeInput {
            width: 100%;
            label {
              width: 25%;
              &:first-of-type:before {
                content: 'From';
              }
              &:before {
                content: 'To';
              }
            }
            input {
              border: 1px solid ${vars.colors.grey20};
              border-radius: 5px;
              box-shadow: none;
              text-align: center;
              margin-top: 5px;
              width: 100%;
              padding: 0;
            }
            button {
              background: ${vars.colors.btnsPrimaryBg};
              text-align: center;
              margin: 21px 0 0 10px;
              line-height: 10px;
              border-radius: 3px;
              &:hover {
                background: ${vars.colors.btnsPrimaryHoverBg};
                border: none;
              }
              &:focus {
                color: ${vars.colors.white};
              }
            }
          }
        }
      `,
    hitWrapper: `
      button {
        width: 100%;
      }
      &.grid-view {
        .class-grid {
          display: block !important;
        }
        .ais-Hits-list {

          grid-template-columns: 1fr;
          grid-gap: 18px;

          @media (min-width: 860px) and (max-width: 1023px) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          @media (min-width: 488px) and (max-width: 767px) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          ${vars.breakpoints.md} {
            grid-template-columns: 1fr 1fr 1fr
          }

          ${vars.breakpoints.xxl} {
            grid-gap: 26px;
          }
          .border-bottom-ccc{
            border-bottom:none;
          }
          .web-description {
            .web-description-content {              
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            @media (max-width: 1365px) {
              display: none !important;
            }
            @media (max-width: 1600px){
              &.case {
                position: absolute;
                top: 66% !important;
              }
            }
            @media (min-width: 1900){
              &.case {
                position: absolute;
                top: 59% !important;
              }
            }
            @media (min-width: 1300px) and (max-width: 1400px) {
              &.case {
                position: absolute;
                top: 57%;
              }
            }
            margin: 20px 0;
            &.case {
              position: absolute;
              top: 70%;
              transform: translateY(-50%);
              margin: 0 auto !important;
              width: 90%;
            }
          }

          @media (min-width: 768px) and (max-width: 1229px) {
            margin-top: 16px;
          }

          .ais-Hits-item {
            display: flex;
            flex-direction: column;
            padding: 0px;
            border: 1px solid #BCBCBC;
            border-radius: 12px;
            transition: box-shadow 0.3s ease-in-out;
            &:not(.hit-item-v2) {
            ${vars.breakpoints.sm} {
              min-height: 570px;
            }
            ${vars.breakpoints.md} {
              min-height: 634px;
              border-radius: 4px;
            }
            ${vars.breakpoints.xl} {
              min-height: 634px;
            }
            }
            &:hover {
              box-shadow: 0px 30px 60px 0px rgba(52, 31, 0, 0.10), 0px 10px 30px 0px rgba(30, 20, 0, 0.10);
            }
            .image-bg {
              width: 100%;
              border-radius: 4px;
              .image-container {
                height: 209px;
                .offer {
                  .stock {
                    position: absolute;
                    left: 10px;
                    bottom: 4px;
                    margin-bottom: 0;
                    z-index: 0;
                  }
                  svg {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                  }
                }
                .image {
                  .bottle {
                    max-width: 52px;
                    height: 177px;
                  }
                }
                .quick-links-container {
                  flex-direction: column-reverse;
                  gap: 15px;
                  bottom: 10px;
                }
                .quick-view-container {
                  display: none;
                }
              }
            }
            &.sponsored-item {
              .image-bg .image-container .offer svg {
                top: 40px;
              }
            }
            .sponsored-badge {
              position: absolute;
              left: 0;
              top: 15px;
              padding: 3px 10px;
              font-size: ${vars.fonts.sizeSmall};
              background-color: ${vars.colors.primary1};
              color: ${vars.colors.white};
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
            }
            .hit-content {
              text-align: center;
              padding: 16px;
              width: 100%;
              margin: 0;
              ${vars.breakpoints.xl} {
                min-height: 160px;
              }
              ${vars.breakpoints.xxl} {
                min-height: 164px;
              }
              min-height: 185px;
              display:flex;
              flex-direction:column;
              justify-content: space-between;
              position: relative;
              .title {
                ${vars.breakpoints.sm} {
                  font-size: 18px;
                  font-weight: 700;
                  line-height: 140%;
                }
                ${vars.breakpoints.xl} {
                  font-size: 22px;
                  font-weight: ${vars.fonts.weightMediumPlus};
                  line-height: 120%;
                }
                ${vars.breakpoints.xxl} {
                  font-size: ${vars.fonts.sizeH8}
                }
              }
              .happy-to-wait-container {
                min-height: 46px;
                background-color: #B3CFE5;
                padding: 8px;
                text-align: center;
                width: 100%;
                border-radius: 4px;
                ${vars.breakpoints.sm} {
                  margin: 10px 0 15px 0;
                }
                ${vars.breakpoints.md} {
                  margin: 4px 0;
                }
                ${vars.breakpoints.xl} {
                  margin: 10px 0 15px 0;
                }
                .date-expected {
                  font-weight: ${vars.fonts.weightBold};
                }
              }
              .inline-container {
                .country-rating{
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                }
                .happy-to-wait-container{
                  min-height: 46px;
                  margin-top: 10px;
                  margin-bottom: 20px;
                }

                justify-content: center;
                flex-direction: column;
                gap: 0;

                .rating {
                  a{
                    span{
                      svg{
                        margin-right:4px;
                      }
                    }
                  }
                  margin-top: 5px;
                  order: 1;
                  justify-content: center;
                }
                .country {
                  color: ${vars.colors.primary8};
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 5px;
                  order: 0;
                  ${vars.breakpoints.sm} {
                    flex-direction: row;
                  }
                  ${vars.breakpoints.md} {
                    flex-direction: row;
                  }
                  ${vars.breakpoints.xl} {
                    flex-direction: row;
                  }
                  .country-grapeVariety.grapeVariety-container {
                    margin-left: 0;
                    ${vars.breakpoints.xl} {
                      margin-left: 8px;
                    }
                    ${vars.breakpoints.xxl} {
                      margin-left: 10px;
                    }
                  }
                }
              }
              .hide-inline-container {
                ${vars.breakpoints.sm} {
                  display: block !important;
                }
                ${vars.breakpoints.md} {
                  display: none !important;
                }
                ${vars.breakpoints.xl} {
                  display: block !important;
                }
              }
              .title {
                margin-bottom: 0px;
                ${vars.breakpoints.md} {
                  min-height: 56px;
                }
                @media (min-width: 1025px) {
                  min-height: 56px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  height: 0;
                }
                @media (min-width: 1366px) {
                  min-height: 56px;
                }
                @media (min-width: 1920px) {
                  min-height: 67px;
                }
                .titleDescSale {
                  height: 100%;
                  line-height: 28px;
                  ${vars.breakpoints.xxl} {
                    height: 90%;
                  }
                  a{
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    height: auto;
                    ${vars.breakpoints.xxl} {
                      height: 100%;
                    }
                  }

                }
              }
              .reserveTodayContainer {
                margin: 0 auto!important;
                width: 90%;
                > div {
                    @media (min-width: 1025px) {
                      padding: 10px;
                      margin-bottom: 10px;
                      margin-right:0;
                      margin-left:0;
                    }
                    ${vars.breakpoints.xl} {
                      padding: 15px;
                      margin: 0 20px 25px 20px;
                    }
                }
                div {
                  border: none;
                }
              }
            }
            .addToCart-container {
                width: 100%;
                padding: 0px 16px;
                ${vars.breakpoints.sm} {
                  position: absolute;
                  bottom: 16px;
                  left: 0;
                  right: 0;
                  margin: 0 auto;
                }
                .member-pricing-container {
                  justify-content: center;
                }
                .lowestPricepossible, .lowestPricePossibleOnOffer {
                  font-family: ${vars.fonts.familySecondary};
                  letter-spacing: 0.18px;
                  font-weight: 700;
                  color: ${vars.colors.primary1};
                  text-align: center;
                  margin-bottom: 3px;
                  &.no-pill-lowestPricepossible {
                    color: ${vars.colors.grey50};
                  }
                  &.no-pill-lowestPricePossibleOnOffer {
                    color: ${vars.colors.grey50};
                  }

                  & + .price-per-litre {
                    color: ${vars.colors.primary1};
                  }
                  &.no-pill-lowestPricepossible + .price-per-litre { 
                    color: ${vars.colors.grey50};
                  }
                @media(min-width: 330px) and (max-width: 460px){
                  margin-bottom:10px;
                }
                @media (min-width: 1025px) {
                  font-size: 14px;
                  line-height: 130%;
                }
                ${vars.breakpoints.lg} {
                  font-size: 16px;
                  line-height: 140%;
                }
                ${vars.breakpoints.xl} {
                  font-size: 16px;
                  line-height: 140%;
                }
                ${vars.breakpoints.xxl} {
                  font-size: 18px;
                  line-height: 140%;
                }
                .strike {
                  font-family: ${vars.fonts.familyTertiary};
                  font-weight: 400;
                  text-decoration: line-through;
                }
                &.presell-primeur {
                  color: #303030;
                  font-weight: 400;
                  font-family: ${vars.fonts.familySecondary};
                  font-size: 16px;
                  .currency {
                    color: ${vars.colors.black};
                    font-weight: 700;
                  }
                }
                &.lowestPricePossibleOnOffer{
                  font-weight:400 !important;
                }
              }
              .maxSavingsContainer {
                text-align: center;
                .saving-section-content {
                  border-radius: 30px;
                  background: ${vars.colors.primary5};
                  font-size: 12px;
                  font-weight: 700;
                  line-height: 18px;
                  padding: 5px 8px;
                  display: inline-block;
                  .saving {
                    color: ${vars.colors.primary1};
                  }
                }
                @media(min-width: 360px) and (max-width: 460px){
                  margin-bottom:10px;
                }
                @media(min-width: 300px) and (max-width: 360px){
                  margin-bottom:30px;
                }
                + .price-per-litre {
                  color: ${vars.colors.primary1};
                  margin-top: 4px;
                }
              }
              .price-per-litre {
                display: block;
                text-align: center;
                font-size: 10px;
                font-weight: 300;
                letter-spacing: 0;
                margin-left: 0;
                margin-top: 2px;
                width: 100%;
                line-height: 17.5px;
              }
              .top-price-section {
                padding-top: 0px;
                padding-bottom: 6px;
                display: block;
                .top-price-section {
                  display: flex !important;
                }
              }
              .single-sku-container {
                text-align: center;
                .top-price-section {
                  justify-content: center;
                  gap: 15px;
                  align-items: center;
                }
              }
              .country {
                justify-content: center;
                gap: 10px;
                height: 50px;
              }
              .plp-offer-info {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
                margin-bottom: 3px;
                  @media (min-width: 1230px) and (max-width: 1365px) {
                    font-size: 13px;
                  }
                  @media (min-width: 1024px) and (max-width: 1135px) {
                    font-size: 13px;
                  }
                  .lowestPricePossibleOnOffer {
                    margin-bottom: 0px;
                  }
                  .plp-info-icon-btn {
                    width: auto;
                    padding: 0;
                    border: none;
                    background: transparent;
                    margin-left: 8px;
                  }
                  .member-pricing-container {
                    justify-content: flex-start;
                  }
                  .price-section .case-details {
                    font-weight: normal;
                  }
                  ${vars.breakpoints.sm} {
                    .mantine-Popover-dropdown {
                      max-width: 450px;
                    }
                  }
                .price-per-litre {
                  display: inline-block;
                  margin-left: 10px;
                  color: inherit;
                  width: auto;
                }
                .member-pricing-container {
                  + .price-per-litre, .price-per-litre {
                    margin-left: 5px; 
                    color: #20513B;
                  }
                }
              }
              @media (max-width: 767px) {
                .mantine-Popover-dropdown {
                  width: calc(100vw - 32px) !important;
                  left: -1px !important;
                }
              }
              @media (min-width: 768px) and (max-width: 1023px) {
                .mantine-Popover-dropdown {
                  width: calc(60vw - 50px)!important;
                }
              }
              .grid-addto-cart-container {
                margin-top: 12px;
                .member-pricing-container {
                  justify-content: center;
                }
                .mantine-Popover-dropdown {
                .member-pricing-container {
                  justify-content: flex-start;
                }
                  @media (min-width: 1025px) {
                    width: 350px !important;
                  }
                  @media (min-width: 1480px) and (max-width: 1680px) {
                    width: 380px !important;
                  }
                  @media (min-width: 1551px) {
                    width: 420px !important;
                  }
                  @media (min-width: 1680px) {
                    width: 480px !important;
                  }
                }
                .grid-addto-cart-btn {
                  background-color: ${vars.colors.btnsPrimaryBg};
                  &:hover {
                    background-color: ${vars.colors.btnsPrimaryHoverBg};
                    color: ${vars.colors.white};
                  }
                }
                .plp-qty-selector-enhanced {
                  .quantityFields {
                    border: none;
                    .quantity {
                      width: 40px;
                      min-height: 34px;
                      text-align: center;
                      padding: 6px;
                      font-size: 16px;
                      color: ${vars.colors.black};
                      border-radius: 5px;
                      border: 1px solid ${vars.colors.grey20};
                      margin: 0 auto;
                      &:focus {
                        outline: none;
                      }
                      &.form-control{
                        border: none;
                      }
                    }
                    .btn {
                      width: 34px;
                      height: 34px;
                      background: ${vars.colors.white};
                      border-radius: 5px;
                      border: 1px solid ${vars.colors.black};
                      color: ${vars.colors.black};
                      padding: 0;
                      cursor: pointer;
                      &:disabled{
                        color: ${vars.colors.grey20};
                        border: 1px solid ${vars.colors.grey20};
                        cursor: auto;
                      }
                    }
                  }
                  .add-to-cart-btn-container {
                    width: 100%;
                  }
                  @media (min-width: 1024px) and (max-width: 1117px), (min-width: 488px) and (max-width: 767px) {
                    .add-to-cart-section {
                      gap: 5px;
                      .quantityFields {
                        padding: 0px 7px 0 0;
                          .btn {
                            width: 28px;
                            height: 28px;
                          }
                          .quantity {
                            width: 30px;
                            min-height: 30px;
                          }
                      }
                      .add-to-cart-btn-container {
                        .grid-addto-cart-btn, .loading-add-to-cart-btn {
                          padding: 8px 20px;
                          height: 34px;
                        }
                      }
                    }
                  }
                }
              }
            }
            &.hit-item-v2 {
              .image-bg {
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
              }
              ${vars.breakpoints.md} {
                border-radius: 4px;
                .image-bg {
                  border-top-left-radius: 4px;
                  border-top-right-radius: 4px;
                }
              }
              .addToCart-container {
                position: unset;
                margin-bottom: 16px;
                margin-top: auto;
              }
              .hit-content { 
                min-height: auto;
                .inline-container {
                  margin-top: 2px;
                }
                .happy-to-wait-container {
                  margin-bottom: 0px;
                }
              }
            }
          }
        }
      }
      &.list-view {
        .class-grid {
          display: none !important;
        }
        .ais-Hits-list {
          grid-template-columns: 1fr;

          .ais-Hits-item {
            border-top: 1px solid #eee;
            display: block;
            box-shadow: none;
            padding: 32px 0px;
            align-items: flex-start;

            &:first-of-type {
              border-top: none;
            }
            &:last-child {
              padding-bottom: 48px;
            }

              display: grid;
              grid-template-columns: 1fr;
              gap: 24px;

              ${vars.breakpoints.lg} {
                grid-template-columns: 240px auto 320px;
              }

              ${vars.breakpoints.xl} {
                grid-template-columns: 340px auto 400px;
              }

              .image-bg {
                border-radius: 8px;
              }

              .hit-content{
                .web-description{
                  height: fit-content;
                  min-height: 0px;
                }
              }

              .offer {
                .stock {
                  position: absolute;
                  left: 10px;
                  bottom: 4px;
                  margin-bottom: 0;
                }
                svg {
                  position: absolute;
                  left: 10px;
                  top: 10px;
                }
              }

              .addToCart-container {
                .country {
                  display: none;
                }
              }


              .quick-links-container {
                flex-direction: column-reverse;
                gap: 15px;
                bottom: 10px;
              }

              .quick-view-container {
                display: none;
              }

          }


        }
      }
      .ais-Hits div + ol {
        @media (min-width: 768px) {
          margin-top: 16px;
        }
      }
      .ais-Hits-list {
        display: grid;
        grid-template-columns: 1fr;
        .ais-Hits-item {
          box-shadow: none;
          position : relative;
          font-size: 1rem;
          .ais-Highlight {
            mark {
              color: ${vars.colors.primary1};
            }
          }

          .title {
            font-size: ${vars.fonts.lineHeightDefault};
            font-family: ${vars.fonts.familyTertiary};
            font-weight: ${vars.fonts.weightBold};
            line-height: 32px;
            margin-bottom: 10px;
          }

          .prod-link {
            a {
              text-decoration: underline;
              &:hover {
                text-decoration: none;
              }
            }
          }

          .pill {
            display: inline-flex;
            padding: 2px 5px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 30px;
            margin: 10px 0px;
            background: rgba(255, 168, 161, 0.4);
            .saving {
              color: ${vars.colors.primary1};
              font-size: 10px;
              font-family: ${vars.fonts.familySecondary};
              font-weight: ${vars.fonts.weightBold};
            }
          }

          .stock {
            background: ${vars.colors.primary6};
            color: ${vars.colors.white};
            font-size: 12px;
            line-height: 18.75px;
            gap: 5px;
            padding: 3px 8px;
            margin-top: 0;
            .case-count {
              font-size: 16px;
              font-weight: 700;
            }
          }

          .hit-content {
            margin-bottom: 5px;
            .inline-container {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              gap: 15px;
              .country-rating{
                margin:10px 0px;
              }
              .rating {
                display: flex;
                align-items: center;
                margin-top: 20px;
                justify-content: center;
                ${vars.breakpoints.sm} {
                  justify-content: start;
                }
                .star-icons {
                  display: flex;
                }
                .review-count {
                  color: ${vars.colors.primary8};
                  font-size: 14px;
                  line-height: 24px;
                  margin-left: 5px;
                  text-decoration: underline;
                }
              }
            }
            .web-description {
              margin-top: 10px;
              margin-bottom: 20px;
              color: ${vars.colors.primary8};
              font-size: ${vars.fonts.sizeLarge};
              line-height: 20px;
              ${vars.breakpoints.xl} {
                font-size: 16px;
                font-weight: 400;
                line-height: 1.4rem;

                text-overflow: ellipsis;
                overflow: hidden;
                height: 0;
                min-height: 46px;
              }
              ${vars.breakpoints.xxl} {
                font-size: ${vars.fonts.sizeLarge};
                line-height: 140%;
                min-height: 44px;
              }
            }
          }

          .image-bg {
            background-color: ${vars.colors.primary3};
            padding: 10px 0px;
            &.gift-image {
              background: none;
              padding: 0px;
              .image-container{
                height: 229px;
                padding: 0px;
              }
              .web-description {
                min-height: 95px!important;
              }
              .image {
                margin: 0px;
                height: 100%;
              }
              .image img {
                border-radius: 10px;
                object-fit: cover;
              }
            }
          }

          .image-container {
            position: relative;
            padding: 20px;
            height: 245px;
            max-height: 245px;
            .image {
              margin: 10px 0px;
              position: relative;
              height: 100%;
              img {
                object-fit: contain;
                object-position: 50% 50%;
                border-radius: 10px;
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                color: transparent;
              }
            }
            .image-center {
              position: relative;
              height: 100%;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0;
            }
            .offer {
              text-align: center;
            }

            .quick-links-container {
              display: flex;
              gap: 10px;
              position: absolute;
              top: 15px;
              right: 15px;
              .zoom, .favourite {
                background: white;
                padding: 5px 5px 0px 5px;
                border-radius: 20px;
                &:hover {
                  cursor: pointer;
                }
              }
            }
            .quick-view-btn {
              position: absolute;
              bottom: 15px;
              right: 15px;
              max-width: 95px;
              padding: 0;
              max-height: 24px;
              border-radius: 4px;
              background-color: ${vars.colors.secondary4};
              .mantine-Button-label {
                font-size: 12px;
                line-height: 14.06px;
                font-weight: 400;
              }
              &:focus {
                color: ${vars.colors.white};
                border-color: transparent;
              }
            }
          }
        }
      }
      li.ais-Hits-item:empty {
        display: none !important;
      }
      @media (max-width: 767px) {
        .ais-Hits-list {
          grid-gap: 30px;
        }
        .ais-Hits-item{
          border-radius: 12px;
          border-top: none;
          border: 1px solid #CCC;
          background: ${vars.colors.white};
          padding: 0px!important;
          .hit-content{
            padding:16px;
            padding-bottom: 0;
            text-align: center;
            .inline-container {
              justify-content: center;
              .rating {
                order: 1;
              }
            }
          }
          .addToCart-container {
            margin:0px 16px 16px 16px;
            .form-control.quantity {
              border:none;
            }
            .customProdQantityField {
              & div:first-of-type {
                min-width:38px;
                margin-right: 8px;
              }
            }
            .add-to-cart-btn-container {
              .cart-button {
                button {
                  padding: 8px 24px;
                  @media (max-width: 374px) {
                    padding: 8px 16px;
                  }
                }
              }
            }
          }
        }
      }
    `,
    searchBoxWrapper: `
      .aa-Autocomplete {
        display: flex;
        flex-direction: column;

        .aa-Form {
          box-shadow: none;
          border: 0;
          border-radius: 50px;
          display: flex;
          width: 100%;
          align-items: center;
          ${vars.breakpoints.lg} {
            border: 1px solid ${vars.colors.grey20};
          }
        }
        .aa-InputWrapperPrefix {
          display: none;
        }
        .aa-InputWrapper {
          padding-left: 0;
          width: 100%;
          .aa-Input {
            border-radius: 50px !important;
            box-sizing: border-box;
            box-shadow: none;
            margin-bottom:0;
          }
        }
        .aa-InputWrapperSuffix {
          padding-right: 10px;
          z-index: 1;
          ${vars.breakpoints.lg} {
            padding-right: 4px;
          }
          button {
            &.aa-ClearButton {
              vertical-align: middle;
              background: ${vars.colors.primary1};
              padding: 5px;
              border-radius: 50px !important;
              color: ${vars.colors.white};
              width: 26px;
              height: 26px;

              ${vars.breakpoints.lg} {
                padding: 8px;
                width: 36px;
                height: 36px;
              }

              svg {
                width: 26px;
                height: 26px;

                &:focus {
                  outline: none;
                }
              }
            }
            &:hover {
            }
          }
        }
      }
      `,
    autocompletePanel: `
        display: flex;
        align-content: stretch;
        column-gap: 30px;

        .ui-container {
          display: flex;
          gap: 25px;
          flex-direction: column;
          ${vars.breakpoints.md} {
            flex-direction: unset;
          }
          .aa-Item {
            &[aria-selected="true"] {
              background-color: transparent;
            }
          }

          ${
            globals?.algoliaNewView &&
            `
              gap: 0px;
              margin-bottom: 50px;
              ${vars.breakpoints.md} {
                gap: 25px;
                margin-bottom: 0px;
              }
              `
          }

          #query-suggestions {
            .aa-ItemIcon {
              display: none;
            }
            .aa-ItemActions {
              display: none;

            }
          }

          #recent-searches {
            .aa-ItemActions button:nth-of-type(1) {
              background-color: transparent;
              padding: 0px;
              display: inline-grid;

              &:hover {
                background-color: transparent;
              }
                svg {
                    background-repeat: no-repeat;
                    background-position: center;
                    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 4L4 12' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M4 4L12 12' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
                    path {
                        display: none;
                    }
                }
            }
            .aa-ItemActions button:nth-of-type(2),
            .aa-ItemIcon {
                display: none;
            }
            .aa-ItemWrapper:hover {
              text-decoration: underline;
            }
            .aa-ItemContentTitle {
                mark {
                    font-weight: ${vars.fonts.weightNormal};
                }
            }
        }

          .results-image {
            box-shadow: none;
            height: 60px;
            min-width: 70px;
            width: 60px;
            img {
              height: 60px;
              max-height: none;
              max-width: none;
            }
            ${
              globals?.algoliaNewView &&
              `height: 83px;
              min-width: 80px;
              width: 70px;
              img {
                height: 83px;
                width:100%;
                object-fit:contain;
              }`
            }
          }
            
          .aa-SourceHeader {
            border-bottom: 1px solid #eee;
            font-size: ${vars.fonts.sizeDefault};
            padding-bottom: 10px;
            text-transform: uppercase;
            white-space: nowrap;
            .aa-SourceHeaderTitle {
              font-size: 1em;
              font-weight: ${vars.fonts.weightNormal};
              color: ${vars.colors.black};
            }
            ${
              globals?.algoliaNewView &&
              `border-bottom: none; 
              text-transform: capitalize; 
              font-size: 16px;
              padding: 10px 0;
              margin: 0;
              .aa-SourceHeaderTitle { font-weight: bold; text-transform: none; }`
            }
          }

          .ui-plugins {
            ${
              globals?.algoliaNewView &&
              `
              order: 3;
                .collection-search {
                  .aa-Source {
                    .aa-List {
                      .aa-Item {
                        padding-left: 0;
                      }
                    }
                  }
                }
                .aa-Source {
                  .aa-List {
                    .aa-Item {
                      padding-left: 0;
                    }
                  }
                }
              ${vars.breakpoints.md} {
                order: 1;
              }
              `
            }
            .aa-Source {
              margin-bottom: 25px;
            }
          }
          .ui-products {
            ${
              globals?.algoliaNewView &&
              `
              order: 2;
              &:empty, &:has(> div:empty) {
                height: auto;
              }
              .no-results-message {
                text-transform: none;
                font-size: 16px;
                white-space: break-spaces;
                ${vars.breakpoints.sm} {
                  font-size: 20px;
                }
              }
              .view-all-items-container a {
                text-decoration: underline;
              }
              .aa-Item:has(.no-results-message) {
                display: none;
              }
              ${vars.breakpoints.md} {
                order: 2;
                padding-bottom: 50px;
                height: calc(98vh - 150px);
                overflow: scroll;
                scrollbar-width: none;
                  .aa-SourceHeader {
                    position: sticky;
                    top: 0;
                    z-index: 1;
                    background: white;
                    padding: 10px 0;
                    margin: 0px;
                  }
              }
              ${vars.breakpoints.lg} {
                height: calc(94vh - 150px);
              }
              &:has(.no-results-message) {
                max-width: 100%
              }
              `
            }
          }
          .ui-recommended {
            ${
              globals?.algoliaNewView &&
              `
              order: 1;
                .aa-Source {
                  margin-bottom: 20px;
                  .aa-SourceHeader {
                    letter-spacing: 0.4px;
                    margin-bottom: 5px;
                    font-size: 18px;
                  }
                  .aa-Item {
                    padding: 0;
                      .recommended-section {
                        .aa-ItemContent {
                          grid-auto-flow: column;
                          align-items: start;
                            .results-image {
                              width: 162px;
                              height: 162px;
                              background-color: ${vars.colors.primary3};
                                img {
                                  height: 145px;
                                }
                            }
                            .aa-ItemContentBody {
                              gap: 10px;
                              padding-top: 10px;
                              padding-left: 5px;
                            }
                        }
                      }
                  }
                }
              ${vars.breakpoints.md} {
                order: 3;
                padding-bottom: 50px;
                  .aa-Source {
                    margin-bottom: 0px;
                    .aa-SourceHeader {
                      letter-spacing: normal;
                      margin-bottom: 10px;
                      font-size: 20px;
                    }
                    .aa-Item {
                      .recommended-section {
                        .aa-ItemContent {
                          grid-auto-flow: row;
                            .results-image {
                              width: 220px;
                              height: 220px;
                              background-color: ${vars.colors.primary3};
                                img {
                                  height: 180px;
                                }
                            }
                            .aa-ItemContentBody {
                              padding-top: 0px;
                              padding-left: 0px;
                            }
                        }
                      }
                    }
                  }
              }
              `
            }
          }
        }
      `,
    searchOverlay: `
        position: fixed;
        left: 0;
        right: 0;
        height: 100%;
        background: ${vars.colors.black};
        opacity: 0.6;
      `,
  },
  Footer: {
    default: `
      font-size: ${vars.fonts.sizeDefault};
      ${vars.mixins.footerBase}
      .footer-nav-links {
        background: ${vars.colors.primary3};
        box-shadow: 0 0 0 100vmax ${vars.colors.primary3};
        .wrapper {
          .navItem-navigation {
            p{
              font-weight: ${vars.fonts.weightBold};
            }
            .tab-panel {
              ul{
                margin: 12px 0px 0px 20px;
                ${vars.breakpoints.lg} {
                  margin-left: 0;
                }
                li {
                  line-height : 35px;
                  padding: 0;
                  a:hover {
                    color: unset;
                  }
                }
              }
            }
          }
        }
      }
      .social-connections,
      .footer-bottom-section {
        color: ${vars.colors.black};
      }
    `,
    navItems: `
      ${vars.mixins.footerNavItems}
    `,
  },
  DrawerMenu: {
    drawerContainer: `
        .mantine-Drawer-overlay {
          z-index: 501;
        }
        .mantine-Drawer-inner {
          z-index: 501;
          left: 0;
        }
        .mantine-Drawer-content {
          flex: 0 0 328px;
          ${vars.breakpoints.sm} {
            flex: 0 0 380px;
          }
        }
        .mantine-Drawer-body {
          padding: 0;
          height: 100%;
          border-top: ${vars.colors.grey20};
          display: flex;
          flex-direction: column;
          .drawer-header-logo-section {
            width: 100%;
            padding: 16px 24px;
            top: 0;
            z-index: 10;
            background-color: ${vars.colors.white};
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0px -1px 0px 0px rgba(204, 204, 204, 1) inset;
            #header-logo a {
              border: 0;
              padding: 0;
              &:focus-visible {
                outline: none;
              }
            }
          }
          .drawer-menu-heading {
            font-weight: ${vars.fonts.weightBold};
            font-size: ${vars.fonts.sizeH4};
            letter-spacing: 0.03em;
            margin: 0;
            background: #EEEAE2;
            padding: 8px 16px;
            text-align: center;
            min-height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;
            color: ${vars.colors.grey50};
            font-family: ${vars.fonts.familySecondary};
            margin-left: -24px;
            margin-right: -24px;
          }
          .drawer-main {
            background: ${vars.colors.primary3};
            height: 100%;
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            overflow-y: scroll;
            overflow-x: hidden;
            padding-left: 24px;
            padding-right: 24px;
            .highlighted-link {
              box-shadow: 0px 1px 0px 0px #DBDBDB inset;
              * {
                color: ${vars.colors.primary1};
                text-decoration: underline;
              }
            }
            a,span {
              font-family: ${vars.fonts.familySecondary};
              font-weight: ${vars.fonts.weightNormal};
              font-size: ${vars.fonts.sizeRoot};
              color: #303030;
              line-height: 18px;
              padding: 12px 0;
              display: block;
              &:hover,&:focus,&:focus-visible {
                text-decoration: none;
                outline: 0;
                background-color: transparent;
              }
              span {
                border: 0;
                padding: 0;
              }
            }
          }
          .drawer-footer-sticky-button-section {
            width: 100%;
            padding: 16px;
            background-color: ${vars.colors.white};
            display: flex;
            boxShadow: 0px -5px 40px 0px rgba(0, 20, 30, 0.1);
            gap: 16px;
            left: 0;
            justify-content: center;
            align-items: center;
            a {
              letter-spacing: 0.03em;
              text-transform: uppercase;
              font-size: ${vars.fonts.sizeSmall};
              padding: 15px 12px;
              line-height: 14px;
              ${vars.breakpoints.sm} {
                padding: 15px 24px;
              },
            },
          },
        },

      `,
    mobileNavMenuContainer: `
        position: relative;
        margin: 0 -24px;

        a{
          padding: 18px 0px; //reapply mantine pad
          border-bottom-width: 1px;
          &:hover{
            text-decoration: none;
          }
        }

        .mantine-Drawer-body & .mantine-NavLink-body,
        .mantine-Drawer-body & .mantine-NavLink-rightSection {
          border: none;
          margin: 0;
          padding: 0;
        }

        .mantine-NavLink-root {
          border-top: 1px solid ${vars.colors.grey20};
          border-radius: 0;
          padding: 15px 24px;
          position: relative;
          display: flex;
          background: transparent;
          color: black;
          margin: 0px;

          &:focus, &:hover{
            background: transparent;
            border-color: transparent;
            border-top: 1px solid ${vars.colors.grey20};
            color: black;
          }
        }

        .mantine-NavLink-children {
          padding-bottom: 20px;

          .mantine-NavLink-root {
            border-top-width: 0;
            padding: 7px 0;
          }
        }

        .mantine-NavLink-root:first-of-type {
          border-top-width: 0;
        }

        .navMenuItemIcon{
          ${vars.icons['chevron-right']}
          :before {
            ${vars.mixins.iconBase}
            font-size: ${vars.fonts.lineHeightDefault};
          }
        }
        .mainnav-mobile-drawer-social-panel {
          display: flex;
          justify-content: center;
          padding: 16px 24px;
          background-color: ${vars.colors.white};
          gap: 55px;
          border-top: 1px solid ${vars.colors.grey20};
          > div {
            a {
              padding: 0;
            }
          }
        }
        .mainnav-mobile-drawer-badges-panel {
          display: flex;
          flex-wrap: wrap;
          padding: 16px 24px;
          align-items: center;
          justify-content: center;
          gap: 10px;
          > div {
            &:nth-of-type(1) {
              flex-basis: 100%;
              text-align: center;
              order: 3;
            }
            a {
              padding: 0;
              border: 0;
            }
          }
        }
        .mainnav-mobile-drawer-footer-links-panel {
          padding: 0 24px;
          > div {
            box-shadow: 0px -1px 0px 0px #DBDBDB inset;
          }
          .navItem-navigation {
            margin: 0;
            p {
              color: ${vars.colors.grey60};
              text-transform: unset;
              font-size: 16px;
              font-weight: ${vars.fonts.weightNormal};
              padding: 16px 0;
            }
            &.navItem-navigation-active div p{
              color: ${vars.colors.primary1};
            }
            .tab-indicator {
              i {
                font-size: ${vars.fonts.lineHeightDefault};
              }
            }
            .tab-indicator.tab-collapse {
              i {
                color: ${vars.colors.grey60};
              }
            }
            .tab-indicator.tab-expand {
              i {
                color: ${vars.colors.primary1};
              }
            }
            .tab-panel {
              border-bottom: 1px solid #DBDBDB;
              ul {
                margin: 0;
                li {
                  padding: 0;
                  a {
                    padding: 12px 0;
                    display: block;
                    color: ${vars.colors.grey50};
                    font-weight: ${vars.fonts.weightNormal};
                    line-height: 18px;
                    text-align: left;
                  }
                }
              }
            }
            &:last-child {
              .tab-panel  {
                border-bottom: 0;
              }
            }
          }
        }

        .level1MenuPane{
          transition: left 0.3s ease;
          position: absolute;
          width: 100%;
          height: auto;
          top: 0;
          & > div.menu-container > div + div {
            display: none;
          }
          .cms-conditional-container:not(:first-of-type) {
            .level1Link:first-of-type {
              border-top: 1px solid ${vars.colors.grey20};
            }
          }

          .level1Link{
            span {
              font-family: ${vars.fonts.headerMainNavTitle};
              font-size: ${vars.fonts.sizeH4};
              font-weight: ${vars.fonts.weightBold};
              letter-spacing: 0.01em;
              text-transform: unset;
              padding: 0;
            }
            &[data-expanded=true] span, &:active span{
              color: ${vars.colors.primary1};
            }

            &.emphasize, &.emphasize span {
              color: ${vars.colors.primary1};
            }
          }
          a.level1Link {
              padding: 15px 24px;
              display: flex;
              font-family: ${vars.fonts.headerMainNavTitle};
              font-size: ${vars.fonts.sizeH4};
              font-weight:  ${vars.fonts.weightBold};
              letter-spacing: 0.01em;
              text-transform: unset;
              text-decoration: none;
              border-bottom: 1px solid ${vars.colors.grey20};

            &.emphasize, &.emphasize span {
              color: ${vars.colors.primary1};
            }

            &:not(:first-of-type) {
              border-top: 1px solid ${vars.colors.grey20};
            }
          }
          a.level1Link:hover {
              color: ${vars.colors.primary1};
          }
          a.level1Link > div {
              margin-right: auto;
          }
        }
        .level2And3MenuPane {
          transition: left 0.3s ease;
          padding: 0 24px;
          position: absolute;
          width: 100%;
          height: 100%;
          .mantine-NavLink-root {
            padding-right: 0;
            padding-left: 0;
            span {
              font-family: ${vars.fonts.familySecondary};
              font-weight: ${vars.fonts.weightMedium};
              font-size: ${vars.fonts.sizeH4};
              color: #303030;
              padding: 0;
            }
            &[data-expanded=true] span{
              color: ${vars.colors.primary1};
              font-weight: ${vars.fonts.weightBold};
            }
            .mantine-NavLink-rightSection[data-rotate] {
              transform: rotate(-90deg);
            }
            &.level2Link .mantine-NavLink-rightSection[data-rotate] {
              transform: rotate(180deg);
            }
            &:last-of-type {
              border-bottom: 1px solid ${vars.colors.grey20};
              &[data-expanded=true] {
                border-bottom: 0;
              }
              + div {
                border-bottom: 1px solid ${vars.colors.grey20};
              }
            }
          }
          .mantine-NavLink-children {
            padding: 0;
            a {
              display: block;
              padding: 12px 0;
              font-weight: ${vars.fonts.weightNormal};
              color: ${vars.colors.grey50};
              text-align: left;
              letter-spacing: 0em;
              &.navMenuSectionLink {
                text-decoration: underline;
                color: ${vars.colors.primary1};
              }
            }
          }
          div.navMenuBackLink{
            border-bottom: 0;
            text-transform: none;
            background: #EEEAE2;
            padding: 8px 16px;
            text-align: center;
            min-height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-left: -24px;
            margin-right: -24px;
            button.navMenuBackButton {
              position: absolute;
              left: 16px;
              background: transparent;
              border: none;
              cursor: pointer;
              padding: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              color: ${vars.colors.grey50};
              &:hover {
                opacity: 0.7;
              }
              i{  
                color: ${vars.colors.grey50};
              }
            }
            span, a.navMenuBackLinkTitle {
              font-family: ${vars.fonts.familySecondary};
              font-weight: ${vars.fonts.weightMediumPlus};
              font-size: ${vars.fonts.sizeH4};
              letter-spacing: 0.03em;
              text-transform: uppercase;
              color: ${vars.colors.grey50};
              border: none;
              padding: 0;
            }
            a.navMenuBackLinkTitle {
              text-decoration: underline;
              &:hover {
                text-decoration: underline;
              }
            }
          }
          .navMenuContent{
            margin-top: 20px;
            //TODO: this tweaks the styling of the link in the MenuBanner but we should
            //find a more elegant/targetted way to fix this
            a{
              border: 0;
              padding: 0;
            }
            .richtext-wrapper {
              p {
                margin-top: ${vars.space.sm};
                margin-bottom: ${vars.space.sm};
                line-height: initial;
                &:first-of-type {
                  margin-top: 0;
                }
                &:last-child {
                  margin-bottom: 0;
                }
                a {
                  line-height: initial;
                }
              }
              &.richtext-has-bg {
                padding: 1rem;
              }
            }
          }
          .navMenuContent:has(.richtext-wrapper){
            margin-bottom: 10px;
            margin-top: 0px;
          }
        }
      `,
  },
  MenuDropdown: {
    dropdown: {
      boxShadow: `0px 2px 20px 0px #00141E33`,
      borderRadius: '12px',
      margin: 0,
      width: '190px !important',
      '&.mantine-Menu-dropdown': {
        padding: '8px 0px 15px',
        maxHeight: 'calc(100vh - 260px)',
        overflowY: 'auto',
        '.sticky-header &': {
          maxHeight: 'calc(100vh - 240px)',
        },
      },
      '&.account-navbar .dynamicComponents': {
        textAlign: 'left',
        a: {
          padding: '8px 21px',
          display: 'block',
        },
      },
    },
    item: {
      textAlign: 'left',
      padding: '8px 21px !important',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
      },
    },
    itemLabel: {
      fontFamily: vars.fonts.familySecondary,
      fontWeight: vars.fonts.weightNormal,
      fontSize: vars.fonts.sizeRoot,
      color: vars.colors.black,
      lineHeight: 'normal',
      '.signout-button &': {
        color: `${vars.colors.primary1}`,
      },
    },
    arrow: {
      border: `1px solid transparent`,
      borderBottomColor: 'transparent',
      borderRightColor: 'transparent',
    },
    divider: {
      borderColor: vars.colors.grey20,
      marginTop: '12px',
      marginBottom: '11px',
    },
  },
  TrustPilotWidget: {
    skeletonWrapperStyle: `
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 24px;
        padding: 60px 0px;
        justify-content: center;
        ${vars.breakpoints.md} {
          justify-content: space-between;
        }
      `,

    headingSkeletonStyle: `
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-width: 200px;
        align-items: center;
      `,

    reviewCardStyle: `
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 12px;
        &:nth-last-child(-n + 4) {
          display: none;
        }
        ${vars.breakpoints.lg} {
          &:nth-child(-n + 4) {
            display: flex;
          }
        }
        ${vars.breakpoints.md} {
          &:nth-child(-n + 2) {
            display: flex;
          }
        }
      `,

    starsAndTitleStyle: `
        display: flex;
        flex-direction: column;
        gap: 6px;
      `,
  },
  CmsConditionalContainer: {
    wrapper: '',
    mobileOnly: `
      ${vars.breakpoints.md} {
        display: none;
      }
    `,
    desktopOnly: `
      display: none;
      ${vars.breakpoints.md} {
        display: block;
      }
    `,
  },
  CmsContentSlot: {
    skeleton: `
    /* shimmer animation */
    @keyframes skeleton-shimmer {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }

    /* base skeleton style */
    &.skeleton {
      background-color: #e6e6e6;
      position: relative;
      overflow: hidden;
    }

    /* animated overlay */
    &.skeleton::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: skeleton-shimmer 1.2s linear infinite;
    }

    /* respects prefers-reduced-motion */
    @media (prefers-reduced-motion: reduce) {
      &.skeleton::after {
        animation: none;
        background: none;
      }
    }`,
  },
  CmsBanner: {
    default: `
      overflow: hidden;
      .banner{
        ${vars.breakpoints.md}{
          padding: 5% 5% 5% 5%;
          position:relative;
        }
        ${vars.breakpoints.lg}{
          padding: 5% 15% 5% 10%;
        }
      }
      .banner-firstgrid{
        position: relative;
        padding:0px;
        margin:0px;
        order:1
      }
      .banner-secondgrid{
        position: relative;
        padding:0px;
        margin:0px;
        order: 2
      }
      .banner-img{
      display: block;
      object-fit:contain;
      }
      .banner-imgcomp{
        ${vars.breakpoints.md}{
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
        }
      }
      .banner-sources{
        padding:0px;
      }
      .banner-title {
          color: ${vars.colors.white};
          font-weight:${vars.fonts.weightMedium};
          padding-bottom: 12px;
          text-align:center;
          margin:0%;
          font-size:22px;
          font-family:${vars.fonts.familyTertiary};
          padding-top:36px;

        ${vars.breakpoints.md}{
          text-align:left;
          font-size:60px;
          font-family:${vars.fonts.familyPrimary};
        }
        }
        .banner-content {
          a {
            color: ${vars.colors.white};
          }
            padding-left:${vars.fonts.sizeLarge};
            padding-right:${vars.fonts.sizeLarge};

          ${vars.breakpoints.md} {
            padding:0px 0px 6px 0px;
          }
        }

      .banner-button{
        display: flex;
        gap: ${vars.space.lg};
        flex-wrap: wrap;
        align-items: center;
        padding:0 ${vars.space.lg};
        ${vars.breakpoints.md}{
          padding:0;
        }
        > .cart-button-wrap {
          width: 100%;
          ${vars.breakpoints.sm} {
            width: auto;  
          }
          .grid-addto-cart-btn {
            width: 100%;
          }
        }
        >a{
          width: 100%;
          text-align: center;
          ${vars.breakpoints.sm}{
            width: auto;
            min-width: 180px;
          }
          button {
            font-size: 12px;
            font-weight: ${vars.fonts.weightMediumPlus};
            text-transform: uppercase;
            letter-spacing: 0.24px;
            min-width: 140px;
            padding: 2px 16px;
            background: transparent;

            cursor: pointer;
            &.darkColor {
              color: ${vars.colors.primary8};
              border: 1px solid ${vars.colors.primary8};
              &:hover {
                background-color: ${vars.colors.btnsPrimaryHoverBg};
                color: ${vars.colors.white};
                border-color: ${vars.colors.btnsPrimaryHoverBg};
              }
            }
            &.lightColor {
              color: ${vars.colors.white};
              border: 1px solid #f8f8f8;
              &:hover {
                background-color: ${vars.colors.white};
                color: ${vars.colors.primary8};
              }
            }
          }
        }
      }
        .banner-info{
          padding: 16px;
          margin-bottom: 24px;
          ${vars.breakpoints.xs}{
            padding: 16px
          }
          ${vars.breakpoints.sm}{
            padding: 30px;
            margin-bottom: 0;
          }
          ${vars.breakpoints.md}{
            padding: 32px
          }
          ${vars.breakpoints.lg}{
            padding: 40px 85px;
          }
          ${vars.breakpoints.xxl}{
            padding: 40px 120px;
          }
        }
      `,
    wrapper: `
        margin-bottom: 12px;
        border-radius: 8px;
        padding: 24px 16px 0;
        ${vars.breakpoints.xs} {
          padding: 16px;
        }
        ${vars.breakpoints.sm} {
          margin-bottom: 24px;
          padding: 24px;
        }
    .banner-info {

      max-width: 764px;
      margin: 0 auto;
      padding: 0;
      .banner-content {
        padding: 0;
        a:hover {
          text-decoration: none;
        }
      }
      .banner-button {
        margin-top: 16px;
        display: flex;
        align-items: center;
        gap: 16px;

        flex-wrap: wrap;
        padding: 0;
        ${vars.breakpoints.xs}{
          gap: 12px;
        }
        a {
          button {
            font-size: 12px;
            font-weight: ${vars.fonts.weightMediumPlus};
            text-transform: uppercase;
            letter-spacing: 0.24px;
            min-width: 140px;
            padding: 2px 16px;
            background: transparent;

            cursor: pointer;
            &.darkColor {
              color: ${vars.colors.primary8};
              border: 1px solid ${vars.colors.primary8};
              &:hover {
                background-color: ${vars.colors.btnsPrimaryHoverBg};
                color: ${vars.colors.white};
                border-color: ${vars.colors.btnsPrimaryHoverBg};
              }
            }
            &.lightColor {
              color: ${vars.colors.white};
              border: 1px solid #f8f8f8;
              &:hover {
                background-color: ${vars.colors.white};
                color: ${vars.colors.primary8};
              }
            }
          }
        }
      }
      h2,
      p {
        margin: 0;
      }
    }
  `,
    bannerSkeleton: `
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        min-height: 300px;
          .text-section{
            flex: 1;
            max-width: 60%;
            margin-left: 40px;
          }
          .image-section{
            margin-left: 40px;
            min-height: 500px;
          }
          .cta-section{
            display: flex;
            gap:10px;
          }
        `,
    BannerWithButton: `
      position:relative;
        .banner-content {
          display: flex;
          flex-direction: column;
          padding:15px !important;
          ${vars.breakpoints.xl} {
            padding:18px !important;
          }
          color: ${vars.colors.btnsPrimaryColor};
          justify-content: space-between;
          width: 100%;
          height: 100%;
          position:absolute;
          background: linear-gradient(90deg, #000 0.05%, rgba(0, 0, 0, 0.00) 107.69%);
          z-index:2;
          .banner-button { 
            margin-top: 10px;
              a {
                margin: 5px;
                button {
                  font-size: 12px;
                  font-weight: ${vars.fonts.weightMediumPlus};
                  text-transform: uppercase;
                  letter-spacing: 0.24px;
                  min-width: 140px;
                  padding: 2px 16px;
                  background: transparent;
                  cursor: pointer;
                  &.darkColor {
                    color: ${vars.colors.primary8};
                    border: 1px solid ${vars.colors.primary8};
                    &:hover {
                      background-color: ${vars.colors.btnsPrimaryHoverBg};
                      color: ${vars.colors.white};
                      border-color: ${vars.colors.btnsPrimaryHoverBg};
                    }
                  }
                  &.lightColor {
                    color: ${vars.colors.white};
                    border: 1px solid #f8f8f8;
                    &:hover {
                      background-color: ${vars.colors.white};
                      color: ${vars.colors.primary8};
                    }
                  }
                }
              }
           }  
        }
        & img{
          min-height:230px;
        }
      `,
    ExternalVideoBackgroundContenVariant: `
      position: relative;
      overflow: hidden;
      > div {
        position: absolute;
        left: 0;
        top: 0;
        ${vars.breakpoints.md} {
          transform: scale(1.55);
        }
        ${vars.breakpoints.lg} {
          transform: scale(1.32);
        }
        ${vars.breakpoints.xl} {
          transform: scale(1.1);
        }
        ${vars.breakpoints.xxl} {
          transform: none;
        }
      }
    `,
    ExternalVideoBackgroundTintedVariant: `
      > .banner {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        margin: 0;
      }
      .external-video-player {
        position: absolute;
        left: 0;
        top: 0;
      }
    `,
  },
  bannerSkeleton: {
    wrapper: `display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      min-height: 300px;
        .text-section{
          flex: 1;
          max-width: 60%;
          margin-left: 40px;
        }
        .image-section{
          margin-left: 40px;
          min-height: 500px;
        }`,
  },

  CmsMenuBanner: {
    wrapper: `
        display: flex;
        flex-direction: column;
        align-items: end;

        .nav-banner-img {
          width: 100%;
          display: block;
          height: auto;
        }
        .main-content-container & {
            display: unset;
            a {
              display: inline-block;
              img {
                width: auto;
              }
            }
        }
      `,
  },
  CmsNavigation: {
    wrapper: `
      `,
    body: `
        &.navigation-link {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;

          a{
            text-wrap:nowrap;
          }
          > a {
            text-wrap:initial;
            line-height: 18px;
            margin-bottom: ${vars.fonts.sizeDefault};
            width: fit-content;
          }
        }
      `,
    sectionLinkFooter: `
        margin-top:20px;
        text-wrap:nowrap;
        a{
          display: inline-block;
          text-decoration: underline;
        }
        i{
          ${vars.mixins.iconBase}
          ${vars.icons['chevron-right']}
          display: inline-block;
          font-size: ${vars.fonts.lineHeightDefault};
          margin-left: 0px;
          ${vars.breakpoints.xl}{
            margin-left: 8px;
          }
        }
      `,
  },
  CmsArticle: {
    wrapper: `
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        > * {
          flex-basis: 50%;
        }
        ${vars.breakpoints.lg} {
          margin-bottom: 0;
        }
        img {
          max-width: 100%;
          height: 100%;
        }
        .article-container {
          .fluid-container & {
            padding: 0 16px;
          }
          margin-top: 24px;
          > p {
            font-weight: ${vars.fonts.weightNormal};
            font-size: ${vars.fonts.fontSize16};
            line-height: 22.4px;
            color: ${vars.colors.grey60};
          }
          h2 {
            margin-top: 8px;
            margin-bottom: 16px;
            color: ${vars.colors.black};
          }
          .secondary {
            color: ${vars.colors.black};
          }
          .date {
            color: ${vars.colors.grey60};
          }
          .article-content {
            color: ${vars.colors.grey60};
            p {
              ${vars.mixins.body1}
            }
          }
        }
      `,
  },
  CmsCarousel: {
    viewport: `
        padding-bottom: 24px;
      `,
    indicators: `
        bottom: 17px;
      `,
    indicator: `
        background: ${vars.colors.secondary9};
        width: 8px;
        height: 8px;
        border-radius: 100%;
        opacity: 1;

        &[data-active] {
          background: ${vars.colors.grey50};
        }
      `,
    controls: `
        position: static;
        margin: 0 auto;
        padding: 0;
        ${vars.breakpoints.sm}{
          max-width: 275px;
        }
      `,
    control: `
        width: 44px;
        height: 44px;
        border-color: ${vars.colors.secondary9};
        svg {
          width: 1.5rem !important;
          height: 1.5rem !important;
        }

        &[data-inactive] {
          background: transparent !important;
        }
      `,
  },
  CmsVideo: {
    videoCompCss: `
        display: flex;
        margin: 0 auto;
        position: relative;
        justify-content: center;
        align-items: center;
        max-width: 1100px;
        margin: 0 auto;

        .main-content-container & .video-container {
          position: relative;
          height: 0;
          width: 100%;
          & > div,
          .cms-image-container img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100% !important;
            height:100% !important;
            object-fit: cover;
          }
          .react-player__shadow {
            display: none !important;
          }
        }
        &.full-width {
          display: grid;
          grid-template-columns: 1fr;
          min-height: 600px;
          height: 100%;
          max-width: none;
          .full-width-overlay {
            grid-row-start: 1;
            grid-column-start: 1;
            width: 100%;
            height: 100%;
            z-index: 1;

            .video-grid {
              height: 100%;
              margin: 0;
              .overlay-content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 100%;
                color: ${vars.colors.white};
                padding: 16px;
                ${vars.breakpoints.sm}{
                  padding: 40px 32px;
                }
                ${vars.breakpoints.xl}{
                  padding: 40px 72px;
                }
                ${vars.breakpoints.xxl}{
                  padding: 40px 120px;
                }
                .play-button {
                  border: 1px solid ${vars.colors.white};
                  padding: 12px 24px;
                  border-radius: 1px;
                  cursor: pointer;

                  display: flex;
                  gap: 8px;
                  align-items: center;
                  justify-content: space-between;
                }
              }
            }
          }
          .video-container {
            grid-row-start: 1;
            grid-column-start: 1;
            width: 100%;
            height: 100%;
            padding: 0 !important;
            .react-player__shadow {
              display: none !important;
            }
            .cms-image-container {
              width: 100%;
              height:100%;
              img {
                width: 100%;
                height: 100%;
                ${vars.breakpoints.xs} {
                  min-height: 600px;
                  object-fit: cover;
                }
              }
            }
            div {
              width: 100% !important;
              height:100% !important;
            }
            ${vars.breakpoints.sm} {
              height:  600px;
            }
            ${vars.breakpoints.md} {
              height:  625px;
            }
          }
        }
        &.playing {
          background-color: ${vars.colors.black};
          .video-container {
            width:100%;
            margin: 0 auto;
            ${vars.breakpoints.xs} {
              width:  100%;
              height: 211px;
            }
            ${vars.breakpoints.sm} {
              width:  100%;
              height: 432px;
            }
            ${vars.breakpoints.md} {
              width:  100%;
              height: 576px;
            }
            ${vars.breakpoints.lg} {
              width:  1068px;
              height: 600px;
            }
          }
        }
      `,
    overlayCss: `
        position: absolute;
        z-index: 2;
        margin: 0 auto;
        display: inline-block;
        cursor: pointer;

        svg {
          width: 47px;
          height: 47px;
          ${vars.breakpoints.sm} {
            width: 90px;
            height: 90px;
          }
        }
      `,
  },
  SlickSlider: {
    wrapper: `
      .slick-slider {
        position: relative;
        display: block;
        box-sizing: border-box;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -khtml-user-select: none;
        -ms-touch-action: pan-y;
        touch-action: pan-y;
        -webkit-tap-highlight-color: transparent;
        overflow: hidden;
        cursor: pointer;
        .slick-list {
          position: relative;
          display: block;
          overflow: hidden;
          padding: 0;
          // width: 1400px;
          margin: 0px 60px;
          .slick-track {
            position: relative;
            top: 0;
            left: 0;
            display: block;
            margin-left: auto;
            margin-right: auto;
            .slick-slide {
              display: block;
              float: left;
              height: 100%;
              min-height: 1px;
              .product-item-container {
                .product-title {
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-family: ${vars.fonts.familyTertiary};
                  ${vars.breakpoints.xs}{
                    font-size: ${vars.fonts.sizeLarge};
                    min-height: auto;
                  }
                  ${vars.breakpoints.sm}{
                    min-height: 43px;
                  }
                  ${vars.breakpoints.lg}{
                    font-size: ${vars.fonts.sizeLarger};
                    min-height: 49px;
                  }
                }
              }
            }
          }
        }
        .slick-list , .slick-track {
          -webkit-transform: translate3d(0, 0, 0);
          -moz-transform: translate3d(0, 0, 0);
          -ms-transform: translate3d(0, 0, 0);
          -o-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
        }
        .slick-arrow {
          cursor: pointer;
          top: 25%;
          transform: translateY(-50%);
          position: absolute;
          background: transparent;
          color: ${vars.colors.black};
          padding: 0;
          i {
            font-size: 60px;
          }
          &.slick-prev {
            left: 0
          }
          &.slick-next {
            right: 0;
          }
          &:focus {
            border-color: transparent;
          }
        }
        .slick-disabled {
          display: none !important;
        }
        .slick-dots {
          display: flex !important;
          justify-content: center;
          margin: 0;
          padding: 1rem 0;
          list-style-type: none;
          li {
            margin: 0 0.25rem;
            button {
              display: block;
              width: 12px;
              height: 12px;
              padding: 0;
              border: none;
              border-radius: 100%;
              background-color: ${vars.colors.grey20};
              text-indent: -9999px;
            }
            &.slick-active {
              button {
                background-color: ${vars.colors.primary1};
              }
            }
          }
        }
        .case-slick-dots {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          display: flex !important;
          justify-content: center;
          margin: 0;
          padding: 1rem 0;
          list-style-type: none;
          li {
            margin: 0 0.25rem;
            button {
              display: block;
              width: 12px;
              height: 12px;
              padding: 0;
              border: none;
              border-radius: 100%;
              background-color: ${vars.colors.grey20};
              text-indent: -9999px;
            }
            &.slick-active {
              button {
                background-color: ${vars.colors.primary1};
              }
            }
          }
        }
      }
      `,
  },
  StateSelector: {
    default: `
      .mantine-Modal-body {
        background: ${vars.colors.primary3};
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        width: 100vw !important;
        overflow-y: auto;
        max-height: 90vh;
        ${vars.breakpoints.lg}{
          border-radius: 12px;
          width: 785px !important;
        }
      }
      .mantine-Modal-inner{
        background: transparent;
        z-index: 999 !important;
        top: auto;
        bottom: 0px;
        padding: 0;
        ${vars.breakpoints.lg}{
          top: 0px;
          bottom: 0px;
        }
      }
      .mantine-Select-input{
        width: 80vw;
        ${vars.breakpoints.lg}{
          width: auto;
        }
      }
      .modal-body-inner {
        padding: 24px;
      }
      .selector-title {
        font-family: ${vars.fonts.familyTertiary};
        font-size: 26px;
        font-weight: ${vars.fonts.weightMediumPlus};
        line-height: 31px;
        letter-spacing: -0.01em;
        text-align: center;
        margin: 0 0 25px;
      }
      .state-selection {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        margin: 24px 0;
        flex-direction: column;
        ${vars.breakpoints.sm} {
          flex-direction: row;
        }
      }
      .state-selector-terms {
        font-family: ${vars.fonts.familySecondary};
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: center;
        max-width: 219px;
        color: ${vars.colors.grey50};
        margin: auto;
      }
      .state-selector-compliance {
        margin-top: 25px;
        color: ${vars.colors.grey70};

        a {
          display: inline-block;
          color: ${vars.colors.grey50};
        }
      }
      button.verify-state-btn {
        width: 142px;
        text-transform: uppercase !important;
        font-weight: ${vars.fonts.weightMediumPlus};
        border-radius: 4px !important;
        padding: 7px 24px;
        font-family: ${vars.fonts.familySecondary} !important;
        background-color: ${vars.colors.primary1};
        &:disabled {
          cursor: not-allowed;
        }
        &:disabled:hover {
          background-color: ${vars.colors.btnDisabled};
        }
        &:hover {
          background-color: ${vars.colors.primary1BtnHover};
        }
      }
      .mantine-Input-input {
        box-sizing: border-box;
        height: 44px;
        border: 1px solid ${vars.colors.grey40};
        border-radius: 4px;
        ${vars.breakpoints.xs} {
          min-width: 343px;
        }
      }
      .mantine-Modal-content {
        border-radius: 12px;
        overflow: unset;
        transition: flex .3s ease-in-out;
      }
      .selector-subtitle {
        font-family: ${vars.fonts.familySecondary};
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: center;
        .error-text {
          color: #c84646;
        }
      }
      .dropdown-item {
        font-family: ${vars.fonts.familySecondary} !important;
        font-size: 14px !important;
        line-height: 18px !important;
        letter-spacing: 0em !important;
        text-align: left !important;
        padding: 12px 10px !important;
        &[data-selected] {
          background-color: ${vars.colors.primary1} !important;
          color: ${vars.colors.white} !important;
          &:hover, &:active{
            background-color: ${vars.colors.primary1} !important;
          }
        }
      }
    `,
    locationWrapper: `
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
    `,
  },

  CmsTabs: {
    root: `
        .mantine-Tabs-tabsList {
          flex-wrap: nowrap;
          overflow-x: auto;
          border-bottom: 1px solid ${vars.colors.black};
        }
      `,
    tab: `
        border-bottom: 4px solid transparent;
        padding: 0 0 12px 0;
        margin-right: 16px !important;

        &[data-active] {
          border-color: ${vars.colors.black};
        }

        &[data-active]:active,
        &[data-active]:hover,
        &:hover {
          background: none;
          border-color: ${vars.colors.black};
        }

        &:last-child {
          margin-right: 0 !important;
        }

        &.highlighted span {
          color: ${vars.colors.primary9};
          font-style: italic;
        }
      `,
    tabLabel: `
        color: ${vars.colors.grey50};
        ${vars.mixins.h8}
      `,
    panel: `
        color: ${vars.colors.grey50};
        padding-top: 24px;
         div p {
          ${vars.mixins.body1}
        }
      `,
  },
  CmsTimer: {
    wrapper: `
        position: relative;
        text-align: center;
        text-transform: uppercase;
        padding: ${vars.space.xl} 0;
        z-index: 1;
        ${vars.breakpoints.lg} {
          padding: 40px 0;
        }
        .timer-headline {
          ${vars.mixins.eyebrowRegular};
          display: inline-block;
          margin-bottom: ${vars.space.sm};
        }
        h2.timer-content {
          margin-bottom: 0;
        }
      `,
  },
  CmsExpander: {
    wrapper: `
        position: relative;
        .expander-content {
          max-height: 0;
          overflow: hidden;
          transition: all 0.2s;
          position: relative;
          z-index: 1;
          padding: 0 ${vars.space.lg};
          * {
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .expander-action {
          text-align: center;
          position: relative;
          z-index: 1;
          button {
            background: none;
            border-top: none;
            border-left: none;
            border-right: none;
            border-radius: 0;
            font-size: 16px;
            font-weight: 400;
            padding: 0;
            margin-top: 8px;
          }
        }
      `,
  },
  CmsTBSPage: {
    wrapper: `
        display: grid;
        max-width: 1920px;
        margin-top: 15px;
        margin-left: auto;
        margin-right: auto;
        ${vars.breakpoints.md} {
          grid-template-columns:380px 1fr;
          grid-gap: 24px;
        }
      `,
    wrapperWithoutSidebar: `
        display: grid;
        max-width: 1920px;
        margin-left: auto;
        margin-right: auto;
        grid-gap: 24px;
        ${vars.breakpoints.md} {
          grid-template-columns: 1fr;
        }
      `,
    sideBar: `
      display:none;
      ${vars.breakpoints.md} {
        display:grid;
        grid-column: 1;
        padding: 50px 10px 30px 45px;
      }
        & div{
          margin:0;
          padding:0;
        }
        & div.navigation-link{
          ${vars.breakpoints.xs} {
              width:260px;
          }
          a{
            font-size: ${vars.fonts.sizeLarge};
            font-family: ${vars.fonts.familySecondary};
            line-height: 22.4px;
            color: ${vars.colors.grey50};
            padding: 12px 16px;
            margin: 0;
          }
          h4{
            font-size:30px;
            color:${vars.colors.primary1};
            font-family: ${vars.fonts.familyTertiary};
            padding: 0 16px;
            margin: 24px 0;
          }
        }
      `,
    sideBarLegacy: `
        background:white;
        padding-left: 5%;
        display:none;
        ${vars.breakpoints.md} {
         display:flex;
         }

         & .sidebar {
            width: 100%;
            background: ${vars.colors.grey10};
            height: fit-content;
            padding-left: 20px;
            margin-bottom: 10px;

            ${vars.breakpoints.md} {
              max-width: 230px;
              margin-right: 15px;
              padding-left: 12px;
            }

            > img {
              width: 14px;
              height: 14px;
            }
           & .navigation-link {
              max-height: fit-content;
              > h4 {
                font-size: 16px;
                color: ${vars.colors.secondary10};
                margin-top: 12px;
                margin-bottom: 15px;
                text-wrap: nowrap;
                font-family: ${vars.fonts.familySecondary};
                width: fit-content;
                 font-weight: ${vars.fonts.weightNormal};
              }
              & a{
                font-size:13px;
                // color: ${vars.colors.footerPrimaryBg};
                 color: ${vars.colors.secondary10};
                margin-left: 4px;
                margin-bottom: 10px;
                text-wrap: nowrap;
                height: 24px;
                    font-weight: normal;
                font-family: ${vars.fonts.familySecondary};
                width: fit-content;
                display: flex;
                gap: 10px;
                > div {
                  overflow-y: hidden;
                   width: 35px;
                  > img {
                    width: 24px;
                    height: 24px;
                  }
                }
              }
           }
         }
            & .accordion-navigation{
          width:200px;
          span {
            padding: 0;
          }
        & .accordion-panel {
          background-color: ${vars.colors.secondary13};
          margin-top: 10px;
        & a{
           text-decoration-color: ${vars.colors.primary1};
           text-decoration-thickness: 2px;
           margin-bottom: 5px;
        }
        }
        & .mantine-Accordion-item{
            width: 100%;
            border:none;
            font-size:13px;
            padding-bottom:19px;
            margin-left: 4px;
            text-wrap: nowrap;
            gap: 10px;
          & button{
            color: ${vars.colors.secondary10};
            padding: 0;
            display: flex;
            justify-content: space-between;
            width: 100%;
          }
          & .mantine-Accordion-content {
            padding:10px 10px;
          }
        }
      }
      `,
    content: `
        display: grid;
        grid-column: 2;
      `,
    contentWithoutSidebar: `
        display: grid;
      `,
    breadcrumbCSS: `
        padding: 12px 24px 12px 0px;
        & a {
          display: flex;
          align-items: center;
          gap: 8px;
          &:hover, &:active, &:focus {
            text-decoration: none;
          }
          & .link-text {
            text-decoration: none;
            border-bottom: 1px solid ${vars.colors.primary8};
            font-size: ${vars.fonts.sizeH5};
            font-weight: bold;
          }
        }
      `,
  },
  CmsMultiCaseSelector: {
    main: `
        position: relative;
        display: grid;
        background: #FAF3E6;

        &::before {
          content: '';
          position: absolute;
          width: 100dvw;
          height: 100%;
          background: #FAF3E6;
          top: 0;
          left: calc(50% - 50dvw);
        }

        ${vars.breakpoints.md} {
          grid-gap: 24px;
          grid-template-columns: 1.28fr 1fr;
          align-items: center;
          padding: 0 40px;
        }

        ${vars.breakpoints.lg} {
          padding: 0 70px;
        }

        .cms-image-container {
          position: relative;
        }

        .mcs-main-row {
          display: grid;
          grid-gap: 8px;
          align-self: baseline;

          h1 {
          color: ${vars.colors.primary9};
            margin: 0;
          }

          .cart-button button {
            width: 100%;
          }

          *:last-child {
            margin-bottom: 0;
          }

          .star-icons {
            display: flex;

            svg {
              width: 16px;
              height: 16px;
            }

            & + span {
              display: none;
            }
          }
        }

        .mcs-main__details {
          position: relative;
          display: grid;
          grid-gap: 24px;
          padding: 24px;

          ${vars.breakpoints.md} {
            padding: 50px 30px;
          }

          ${vars.breakpoints.lg} {
            padding: 50px;
          }
        }

        .mcs-main-media {
          position: relative;
        }

        .mcs-main-row--upsell {
          ${vars.mixins.body2};
          color: #494949;

          > div {
            display: flex;
            align-items: center;
            gap: 16px;
          }

          label,
          button {
            width: 100%;
          }

          [type="checkbox"] {
            width: 20px;
            height: 20px;
            accent-color: #117B53;
          }

          button span {
            width: 178px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            ${vars.breakpoints.md} {
              width: auto;
            }
          }
          
          button {
            img + span {
              margin-left: 8px;
            }
          }
        }

        .mcs-main-row--active-info {
          ${vars.mixins.body1};
        }

        .mcs-price-rating {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .product-price__original {
          color: #767676;

          + span {
            padding-left: 4px;
          }
        }

        .product-price-sale {
          color: ${vars.colors.textPrimaryBg};
        }

        .mcs-main-desc {
          padding-top: 24px;
          padding-bottom: 24px;

          ${vars.breakpoints.md} {
            padding-top: 28px;
            padding-bottom: 30px;
          }
        }

        .mcs-main-desc span + section {
          margin-top: 16px;
        }

        .mcs-main-desc p:last-child {
          margin-bottom: 0;
        }
      `,
    info: `
        position: relative;
        background: #fff !important;
        padding: 40px 16px;
        max-width: 1348px;
        margin: 0 auto;

        &:before {
          content: '';
          position: absolute;
          width: 100dvw;
          height: 100%;
          background: #ffffff;
          left: calc(50% - 50dvw);
          top: 0;
        }
        
        ${vars.breakpoints.md} {
          padding: 80px 24px;
        }

        #panel-case-selector,
        .case-content-container {
          position: relative;
        }

        .case-content-container .mantine-Tabs-tab {
          opacity: 0.3;

          &[data-active] {
            opacity: 1;

            &::after {
              content: none !important;
            }
          }
        }

        .case-content-container .mantine-Tabs-panel {
          margin: 0;
        }

        .case-content-container {
          margin-top: 30px;
        }

        .point-text-container {
          top: 0 !important;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .point-text-container .point {
          font-size: 12px !important;
        }
        .point-text,
        .rating-container {
          display: none !important;
        }

        .main-title {
          margin: 0 !important;

          a {
            color: inherit !important;
          }
        }

        .web-description,
        [role="tabpanel"] .price {
          display: none;
        }

        .case-content-details-section {
          display: grid;
          grid-gap: 0;
          margin-top: 0 !important;

          ${vars.breakpoints.md} {
            grid-template-columns: 1fr 1fr !important;
            grid-gap: 24px;
          }

          .wine-details,
          .case-details {
            padding: 24px 16px;

            ${vars.breakpoints.md} {
              padding: 40px 0 0;
            }
          }

          .case-image,
          .share-print {
            display: none;
          }

          .sub-title-with-border {
            ${vars.mixins.h3}
            font-family: ${vars.fonts.familyPrimary};
            border: none;
          }
        }

        .case-content-container .mantine-Tabs-panel {
          padding: 24px 16px;

          ${vars.breakpoints.md} {
            padding: 40px 56px;
          }
        }

        .header-container {
          padding-bottom: 16px;
          border-bottom: 1px solid #B79178;
        }

        // Mobile Carousel Style
        .mantine-Carousel-root {
          padding-bottom: 24px;
        }

        .mantine-Carousel-viewport {
          padding-bottom: 40px;
        }
        .mantine-Carousel-slide {
          .mantine-Tabs-tab {
            display: grid;
            grid-gap: 8px;
            width: 100%;
            height: 150px;

            span {
              margin: 0;
              text-align: center;
            }

            &[data-active] {
              border: none;
            }
          }
        }

        .mantine-Carousel-control {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);

          &:last-child {
            left: auto;
            right: 0;
          }
        }

        .mantine-Carousel-indicators {
          position: static;
          transform: none;
        }
      `,
    caseSelectors: `
        .mcs-selector__header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            font-family: ${vars.fonts.roboto};
            font-size: 14px;
            font-weight: 700;
            line-height: 15.6px;
            text-align: left;

          }

          a {
            text-decoration: underline;
          }
        }
        
        .mcs-selector__list {
          display: grid;
          grid-gap: 8px;

          &.simple {
            display: flex;
            overflow-y: auto;
            padding-bottom: 10px;
          }

          img + span {
            margin-left: 8px;
          }
        }
      `,
    caseSelector: `
        background: #FAF3E6;
        display: flex;
        align-items: center;
        padding: 8px 10px;
        outline: none;
        border: 1.5px solid #B79178;
        border-radius: 4px;
        box-shadow: none;

        &[aria-selected="true"] {
          background: ${vars.colors.white};
          border-color: ${vars.colors.primary9};
        }

        &.simple {
          border: 1px solid #BCBCBC;
          background: ${vars.colors.white};
          font-weight: 400;

          &[aria-selected="true"] {
            background: #FEF5F8;
            color: ${vars.colors.primary9};
          }
        }

        img {
          width: 84px !important;
          height: 43px !important;
          object-fit: contain;
        }
      `,
  },
  CmsLink: {
    button: `
        &.full-width {
          width: 100%;
          button {
            width: 100%;
            text-align: center;
          } 
        }
        &.stick-add-to-cart {
            .cart-button button {
              width: 100%;
            }
            position: fixed;
            border: none;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 0px;
            box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
            z-index: 1;
            ${vars.breakpoints.lg} {
              display: none;
            }
          }
      `,
  },
  CmsRichText: {
    wrapper: `
        table {
          height: auto !important;
          max-width: 100%;
          display: block;
          overflow-x: auto;
          white-space: nowrap;
          padding-bottom: 10px;
          ${vars.breakpoints.md} {
            display: table;
            overflow-x: visible;
            white-space: normal;
          }
          td, th {
            padding: 12px;
            width: auto !important;
            border: 1px solid transparent;
            &.richtext-background {
              display: table-cell;
            }
          }
        }
      `,
  },

  CmsVoucherWidget: {
    main: `
      position: relative;
      padding: 80px 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      ${vars.breakpoints.xxl} {
        padding: 5.55vw 24px;
      }

      .cms-image-container img {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .voucher-widget__card {
        position: relative;
        padding: 60px 24px 32px;
        background: ${vars.colors.white};
        border-radius: 8px;
        display: grid;
        grid-gap: 24px;
        max-width: 496px;
        
        button {
          text-transform: uppercase;
          letter-spacing: 0.03em;
          padding-top: 7px;
          padding-bottom: 7px;
        }

        ${vars.breakpoints.md} {
          grid-gap: 32px;
          padding: 60px 40px 40px;
        }
      }

      .voucher-widget__text {
        display: grid;
        grid-gap: 6px;
        ${vars.breakpoints.md} {
          grid-gap: 8px;
        }
      }

      .voucher-widget__form,
      .voucher-widget__form form {
        display: grid;
        grid-gap: 24px;
        ${vars.breakpoints.md} {
          grid-gap: 32px;
        }
      }

      .voucher-widget__form .field-container input {
        height: 44px;
      }
      
      .voucher-widget__form .field-container input:focus~label, 
      .voucher-widget__form .field-container input:-webkit-autofill~label,
      .voucher-widget__form .field-container input:not(:placeholder-shown)~label {
        top: -5px;
      }
      
      .voucher-widget__eyebrow {
        font-family: ${vars.fonts.roboto};
        font-weight: ${vars.fonts.weightBold};
        font-size: ${vars.fonts.sizeLarge};
        line-height: 1.4;
        text-transform: uppercase;
      }

      h1.voucher-widget__headline {
        margin: 0;
      }

      .voucher-widget__promo-text {
        position: absolute;
        left: 0;
        top: 16px;
        padding: 5px 8px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        font-family: ${vars.fonts.familySecondary};
        background: ${vars.colors.primary9};
        color: ${vars.colors.white};

        ${vars.breakpoints.md} {
          padding: 6px 10px;
        }
      }

      .voucher-widget__subcta * {
        font-size: ${vars.fonts.sizeDefault} !important;

        &:last-child {
          margin: 0 !important;
        }
      }
      .voucher-widget__subcta a {
        text-decoration: underline;
      }
    `,
  },
  FooterDropDown: {
    main: `
        margin: 15px auto;

      ${vars.breakpoints.sm} {
        margin: 15px 15%;
      }

      .mantine-Accordion-item {
        border: none;
        border-bottom: 1px solid #e0e0e0;
        background-color: transparent;

        &[data-active] {
          background-color: transparent;
        }

        .mantine-Accordion-label {
          font-weight: bold;
          font-size: 16px;
          color: #545454;
        }

        .mantine-Accordion-content {
          color: #545454;
        }
      }

      .logo {
        margin-top: 15px;
        text-align: center;
      }

      a {
        text-decoration: underline;
      }
    `,
  },
});
